import { Component, ElementRef, Renderer2, ViewChild, TemplateRef } from '@angular/core';
import { Http } from "@angular/http";

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, filter, reduce } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MiraieService } from '../Services/miraie.service';
import { AuthService } from '../Services/auth.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { FormService } from "../Services/form.service";
import { CalendarService } from '../Services/calendar.service';
import { ScService } from '../search-data/sc.service';
import * as constant from '../constant';
import { Logininfo } from '../classes/Loginifo';
import { StringUtil } from '../classes/StringUtil';

@Component({
  selector: 'app-customer-input',
  templateUrl: './customer-input.component.html',
  styleUrls: ['./customer-input.component.css']
})
export class CustomerInputComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  sc = this.scService.sc;
  @ViewChild('itvw_add') itvw_add: TemplateRef<any>;

  input: any = {
    division_code: "",
    sales_contact_code: "",
    customer_code: "",
    customer_family_name: "",
    customer_name: "",
    joint_name1: "",
    joint_name2: "",
    kana_family_name: "",
    kana_name: "",
    birthday: "",
    b_year: "",
    b_month: "",
    b_date: "",
    gender: "",
    zip_code: "",
    pref: "",
    city: "",
    address: "",
    tel_number: "",
    fax_number: "",
    mobile_number: "",
    mail_address: "",
    note: "",
    family_name1: "",
    family_relation1: "",
    family_bitrh1: "",
    fb_year1: "",
    fb_month1: "",
    fb_day1: "",
    family_name2: "",
    family_relation2: "",
    family_bitrh2: "",
    fb_year2: "",
    fb_month2: "",
    fb_day2: "",
    family_name3: "",
    family_relation3: "",
    family_bitrh3: "",
    fb_year3: "",
    fb_month3: "",
    fb_day3: "",
    family_name4: "",
    family_relation4: "",
    family_bitrh4: "",
    fb_year4: "",
    fb_month4: "",
    fb_day4: "",
    family_name5: "",
    family_relation5: "",
    family_bitrh5: "",
    fb_year5: "",
    fb_month5: "",
    fb_day5: "",
  };

  question: any = {
    family_structure: "",
    parent_num: "",
    children: "",
    children_num: "",
    income: "",
    car: "",
    q_land: "",
    a1: {},
    a1_introducer: "",
    a1_other: "",
    a2_1: "",
    a2_2: "",
    a2_3: "",
    a2_1_memo: "",
    a2_2_memo: "",
    a2_3_memo: "",
    a2_1_introduced: "",
    a2_2_introduced: "",
    a2_3_introduced: "",
    a3: {},
    a3_other: "",
    a4: "",
    a4_memo: "",
    a5: "",
    a5_other: "",
    a6: "",
    a7_1: "",
    a7_1_other: "",
    a7_1_reason: "",
    a7_2: "",
    a7_2_other: "",
    a7_2_reason: "",
    a7_3: "",
    a7_3_other: "",
    a7_3_reason: "",
    a7_4: "",
    a7_4_other: "",
    a7_4_reason: "",
    a7_5: "",
    a7_5_other: "",
    a7_5_reason: "",
    a8: {},
    a8_99: "",
    a8_other: "",
  };

  point: any = {
    status: 0,
    rank: 8,
    rank_ob: 0,
    introduction: 0,
    warning: 0,
    loss: "",
    total_points: 0,//総ポイント数

    land_points: 0,//土地ポイント数
    land_owner: "",//土地所有
    land_buying: "",//土地_買付申込書
    land_lord_consent: "",//土地_地主の承諾書
    land_public_figure: "",//土地_公図
    land_transcript_land: "",//土地_謄本（土地）
    land_transcript_build: "",//土地_謄本（建物））
    land_survey_land: "",//	土地_測量図（土地）
    land_survey_build: "",//土地_謄本（建物）
    land_value: "",//土地_路線価図
    land_lord_entering: "",//土地_地主の立入許可
    land_survey: "",//土地_現地調査・役所調査
    land_dismantling: "",//土地_解体工事
    land_dismantling_estimate: "",//土地_解体工事見積依頼
    land_preparation: "",//土地_造成工事
    land_preparation_estimate: "",//土地_造成工事見積依頼
    land_sewage: "",//土地_上下水道取出
    land_sewage_estimate: "",//土地_上下水道見積依頼
    land_lease: "",//土地_賃貸借契約
    land_bound: "",//土地_境界確定案内
    land_note: "",//土地_備考

    capital_points: 0,//資金ポイント数
    capital_finance_type: "",//資金_資金種別
    capital_comp: "",//資金_資金成立
    capital_balance_plan: "",//資金_事業収支計画
    capital_identification: "",//資金_本人確認書類（合算者含）
    capital_privacy: "",//資金_個人情報
    capital_health_insurance: "",//資金_健康保険証（合算者含）
    capital_temporary_subsecription: "",//資金_事前審査記入
    capital_temporary_approval: "",//資金_事前審査承認
    capital_loan_consultant: "",//資金_融資打診了解
    capital_rough_finance_plan: "",//資金_概算資金計画内容合意
    capital_finance_plan: "",//資金_資金計画書・見積内容合意
    capital_note: "",//資金_備考

    plan_points: 0,//プランポイント数
    plan_hearing: "",//プラン_ヒアリング
    plan_suggestion: "",//プラン_提案
    plan_confirm: "",//プラン_プラン確定
    plan_law: "",//プラン_法規確認（役所他）
    plan_approval: "",//プラン_承認図書受領
    plan_solar: "",//プラン_太陽光
    plan_note: "",//プラン_備考

    conflict_points: 0,//競合ポイント数
    conflict: "",//競合_競合
    conflict_note: "",//競合_備考

    affected_points: 0,//影響者ポイント数
    affected: "",//影響者_影響者
    affected_note: "",//影響者_備考

    time_points: 0,//時期ポイント数
    time_timing: "",//時期
    time_note: "",//時期_備考

    visit_points: 0,//見学ポイント数
    visit_construct: "",//見学_構造現場
    visit_model: "",//見学_構造現場
    visit_ob: "",//見学_構造現場
    visit_note: "",//見学_備考

    opertor_points: 0,//運営事業者ポイント数
    opertor_open_confirm: "",//運営事業者_出店確認
    opertor_sublease: "",//運営事業者_サブリース契約
    opertor_note: "",//運営事業者_備考

    app_poins: 0,//申込ポイント数
    app_pay: "",//申込_申込（入金済）
    app_note: "",//申込_備考

    lost_cause1: "",//失注原因
    lost_cause2: "",//失注原因2

    contract_amount: 0,//請負金額
    prospective_sales: 0,//見込売上
    expected_gross_margin: 0,//見込粗利
    finalized_sales: "",//確定売上
    decided_gross_profit: "",//確定粗利

  };

  schedule: any = {
    directer_code: "",
    start_hour: "",
    start_minute: "",
    end_hour: "",
    end_minute: "",
    location: "",
    land_area: "",
    finance_application: "",
    construction_payment: "",
    midway_payment: "",
    final_payment: "",
    ground_prayer_none: false,
    other_resuest_flg: "",
    delivery_flg: "",
    delivery_target_flg: "",
    after_flg: "",
    midway_check_flg: "",
    improvement_flg: ""
  };

  interview: any = {
    user_calendar_code: 0,
    date: null,
    start_hour: "",
    start_minute: "",
    end_hour: "",
    end_minute: "",
    user_code: "",
    support_flg: false,
    supporter_code1: "",
    supporter_code2: "",
    supporter_code3: "",
    title: "",
    place: "",
    event_calendar_code: "",
    contents: "",
    child_flag: 0,
    upfile: "",
    upfile_name: null,
    upfile_chk: null,
    is_next_app: false,
    visit_apply: false,
  };
  interview_edit: any = {
    support_flg: false,
    supporter_code1: "",
    supporter_code2: "",
    supporter_code3: "",
    upfile_name: null,
    upfile_chk: null,
    is_next_app: false,
    visit_apply: false,
  };
  imglist: any = {
    img_name: "",
    img_memo: "",
  };
  imglist_edt: any = {
    img_name: "",
    img_memo: "",
    del_chk: "",
  };
  imglists: any;
  itvw_imgname: string;
  noticelists: any;
  notice_ad = {
    notice_user_code: '',
    notice: '',
  };
  notice_ed = {
    notice_id: "",
    notice_user_code: "",
    notice: "",
    del_chk: "",
  };
  bulk = {
    add_day: 0,
    ac_flg: false,
    all_check: false,
    approval_book_get_date_target: false,
    four_people_meeting_target: false,
    final_decision_mark_target: false,
    approval_book_get_date: false,
    four_people_meeting: false,
    final_decision_mark: false,
    other_resuest_date1_target: false,
    other_resuest_approval_date1_target: false,
    other_resuest_date2_target: false,
    other_resuest_approval_date2_target: false,
    other_resuest_date3_target: false,
    other_resuest_approval_date3_target: false,
    other_resuest_date4_target: false,
    other_resuest_approval_date4_target: false,
    other_resuest_date1: false,
    other_resuest_approval_date1: false,
    other_resuest_date2: false,
    other_resuest_approval_date2: false,
    other_resuest_date3: false,
    other_resuest_approval_date3: false,
    other_resuest_date4: false,
    other_resuest_approval_date4: false,
    confirm_resuest_date_target: false,
    confirm_resuest_approval_date_target: false,
    confirm_resuest_date: false,
    confirm_resuest_approval_date: false,
    construction_approval_request: false,
    construction_approval_request_target: false,
    construction_approval_date_target: false,
    construction_approval_date: false,
    construction_payment_plandate: false,
    construction_payment_date: false,
    gl_layout_target: false,
    ground_prayer_target: false,
    base_construction_date_target: false,
    gl_layout: false,
    ground_prayer: false,
    base_construction_date: false,
    midway_payment_plandate: false,
    midway_payment_date: false,
    upper_build_date_target: false,
    outlet_target: false,
    upper_build_date: false,
    outlet: false,
    midway_check_date_target: false,
    midway_check_date: false,
    framework_end_date_target: false,
    company_inspection_date_target: false,
    complete_check_date_target: false,
    completion_date_target: false,
    framework_end_date: false,
    company_inspection_date: false,
    complete_check_date: false,
    completion_date: false,
    final_payment_plandate: false,
    final_payment_date: false,
    furniture_carryout_start_date: false,
    furniture_carryout_end_date: false,
    furniture_carryout_start_date_target: false,
    furniture_carryout_end_date_target: false,
    complete_visit_start_date_target: false,
    complete_visit_end_date_target: false,
    complete_visit_start_date: false,
    complete_visit_end_date: false,
    delivery_date: false,
    delivery_date_target: false,
    after_date1: false,
    after_date2: false,
    after_date3: false,
    after_date1_target: false,
    after_date2_target: false,
    after_date3_target: false,
  };
  divisions: any;
  users: any;
  sales_users: any;
  construction_users: any;
  place_list: any;
  app_place_list: any;
  a1: string[];
  a2: string[];
  a3: string[];
  a8: string[];
  Prefectures: string[];
  years: string[];
  months: string[];
  days: string[];
  days1: string[];
  days2: string[];
  days3: string[];
  days4: string[];
  days5: string[];
  detail_update_list: any;
  detail_interview_list: any;
  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;

  tm_pay_c: number = 0;
  tm_pay_p: number = 0;
  tm_pay_name_c = "";
  tm_pay_name_p = "";
  nm_pay_c: number = 0;
  nm_pay_p: number = 0;
  nm_pay_name_c = "";
  nm_pay_name_p = "";

  message: string;
  error: string;
  error_mdl: string;
  srcurl: string;
  fcdc_flg = true;
  modalReference: NgbModalRef;

  fcaCheck: boolean = false;
  fcdCheck: boolean = false;
  apoCheck: boolean = false;
  apoDoneCheck: boolean = false;
  apoCanCheck: boolean = false;

  tab = this.formService.tab;
  active = this.formService.active;

  displayMonths: number;
  navigation: string = 'select';
  outsideDays: string = 'visible';
  showWeekNumbers: boolean = true;

  fsi_flg: boolean = false;
  ds_flg: boolean = false;
  gsrd_flg: boolean = false;
  gsid_flg: boolean = false;
  dsd_flg: boolean = false;
  ded_flg: boolean = false;
  gsd_flg: boolean = false;
  ged_flg: boolean = false;
  gid_flg: boolean = false;
  ord_flg: boolean = false;
  gpn_flg: boolean = false;
  mcd_flg: boolean = false;
  fcd_flg: boolean = false;
  cvd_flg: boolean = false;

  ft_setHour: number = 8;
  ft_setMinute: number = 0;
  ed_setHour: number = 8;
  ed_setMinute: number = 0;

  eventAllList: any = [];
  eventList: any = [];

  jointNameLength = 0;

  //タブ切り替え
  _handleClick(event: MouseEvent): void {
    const element = event.currentTarget as HTMLElement;
    const tabState = element.getAttribute('aria-controls');
    this.tab = tabState;
  }

  constructor(
    private _el: ElementRef,
    private renderer: Renderer2,
    private http: Http,
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private miraieService: MiraieService,
    public authService: AuthService,
    public customerInputService: CustomerInputService,
    private scService: ScService,
    private formService: FormService,
    private calendar: CalendarService,
  ) { }

  ngOnInit() {
    this.sc = this.scService.sc;
    this.tab = this.formService.tab;
    this.active = this.formService.active;
    this.srcurl = this.miraieService.srcurl;
    this.a1 = this.formService.a1;
    this.a2 = this.formService.a2;
    this.a3 = this.formService.a3;
    this.a8 = this.formService.a8;
    this.fsi_flg = false;

    this.getEventList(new Date());
    //顧客詳細表示用
    const customer_code = +this.route.snapshot.paramMap.get('id');
    if (customer_code) {
      let detail = this.customerInputService.customerDetail(customer_code);
      detail.subscribe(detail => {
        this.input = detail['detail'];
        if ((!this.input.joint_name1 || this.input.joint_name1 == '') && this.input.joint_name2) {
          this.input.joint_name1 = this.input.joint_name2;
          this.input.joint_name2 = '';
        }
        if (this.input.joint_name1 && this.input.joint_name1 != '') {
          this.jointNameLength++;
        }
        if (this.input.joint_name2 && this.input.joint_name2 != '') {
          this.jointNameLength++;
        }

        this.question = detail['question'];
        if (this.question.a1) {
          this.question.a1 = this.question.a1.split(",");
        } else {
          this.question.a1 = {};
        }
        if (this.question.a3) {
          this.question.a3 = this.question.a3.split(",");
        } else {
          this.question.a3 = {};
        }
        if (this.question.a8) {
          this.question.a8 = this.question.a8.split(",");
        } else {
          this.question.a8 = {};
        }

        this.point = detail['point'];

        if (this.input.birthday) {
          this.input.b_year = this.formatDate1(new Date(this.input.birthday), 'yyyy');
          this.input.b_month = this.formatDate1(new Date(this.input.birthday), 'M');
          this.input.b_date = this.formatDate1(new Date(this.input.birthday), 'd');
          this.days = this.formService.formSetDay(this.input.b_year, this.input.b_month);
          this.birthDay(this.input.b_year, this.input.b_month, this.input.b_date);
        }
        if (this.input.family_bitrh1) {
          this.days1 = this.formService.formSetDay(this.formatDate1(new Date(this.input.family_bitrh1), 'yyyy'), this.formatDate1(new Date(this.input.family_bitrh1), 'M'));
          this.input.fb_year1 = this.formatDate1(new Date(this.input.family_bitrh1), 'yyyy');
          this.input.fb_month1 = this.formatDate1(new Date(this.input.family_bitrh1), 'M');
          this.input.fb_day1 = this.formatDate1(new Date(this.input.family_bitrh1), 'd');
        }
        if (this.input.family_bitrh2) {
          this.days2 = this.formService.formSetDay(this.formatDate1(new Date(this.input.family_bitrh2), 'yyyy'), this.formatDate1(new Date(this.input.family_bitrh2), 'M'));
          this.input.fb_year2 = this.formatDate1(new Date(this.input.family_bitrh2), 'yyyy');
          this.input.fb_month2 = this.formatDate1(new Date(this.input.family_bitrh2), 'M');
          this.input.fb_day2 = this.formatDate1(new Date(this.input.family_bitrh2), 'd');
        }
        if (this.input.family_bitrh3) {
          this.days3 = this.formService.formSetDay(this.formatDate1(new Date(this.input.family_bitrh3), 'yyyy'), this.formatDate1(new Date(this.input.family_bitrh3), 'M'));
          this.input.fb_year3 = this.formatDate1(new Date(this.input.family_bitrh3), 'yyyy');
          this.input.fb_month3 = this.formatDate1(new Date(this.input.family_bitrh3), 'M');
          this.input.fb_day3 = this.formatDate1(new Date(this.input.family_bitrh3), 'd');
        }
        if (this.input.family_bitrh4) {
          this.days4 = this.formService.formSetDay(this.formatDate1(new Date(this.input.family_bitrh4), 'yyyy'), this.formatDate1(new Date(this.input.family_bitrh4), 'M'));
          this.input.fb_year4 = this.formatDate1(new Date(this.input.family_bitrh4), 'yyyy');
          this.input.fb_month4 = this.formatDate1(new Date(this.input.family_bitrh4), 'M');
          this.input.fb_day4 = this.formatDate1(new Date(this.input.family_bitrh4), 'd');
        }
        if (this.input.family_bitrh5) {
          this.days5 = this.formService.formSetDay(this.formatDate1(new Date(this.input.family_bitrh5), 'yyyy'), this.formatDate1(new Date(this.input.family_bitrh5), 'M'));
          this.input.fb_year5 = this.formatDate1(new Date(this.input.family_bitrh5), 'yyyy');
          this.input.fb_month5 = this.formatDate1(new Date(this.input.family_bitrh5), 'M');
          this.input.fb_day5 = this.formatDate1(new Date(this.input.family_bitrh5), 'd');
        }

        this.schedule = detail['schedule'];
        if (this.schedule.app_date) {
          this.schedule.app_date = this.dateArr(this.schedule.app_date);
        }
        if (this.schedule.temporary_reception_date) {
          this.schedule.temporary_reception_date = this.dateArr(this.schedule.temporary_reception_date);
        }
        if (this.schedule.temporary_approval_date) {
          this.schedule.temporary_approval_date = this.dateArr(this.schedule.temporary_approval_date);
        }
        if (this.schedule.app_schedule_date) {
          this.schedule.app_schedule_date = this.dateArr(this.schedule.app_schedule_date);
        }
        if (this.schedule.temporary_reception_schedule_date) {
          this.schedule.temporary_reception_schedule_date = this.dateArr(this.schedule.temporary_reception_schedule_date);
        }
        if (this.schedule.temporary_approval_schedule_date) {
          this.schedule.temporary_approval_schedule_date = this.dateArr(this.schedule.temporary_approval_schedule_date);
        }
        if (this.schedule.closing_schedule_date) {
          this.schedule.closing_schedule_date = this.dateArr(this.schedule.closing_schedule_date);
        }
        if (this.schedule.contract_schedule_date) {
          this.schedule.contract_schedule_date = this.dateArr(this.schedule.contract_schedule_date);
        }
        if (this.schedule.contract_date) {
          this.schedule.contract_date = this.dateArr(this.schedule.contract_date);
        }
        if (this.schedule.land_contract_target_date) {
          this.schedule.land_contract_target_date = this.dateArr(this.schedule.land_contract_target_date);
        }
        if (this.schedule.land_contract_result_date) {
          this.schedule.land_contract_result_date = this.dateArr(this.schedule.land_contract_result_date);
        }
        if (this.schedule.land_settlement_target_date) {
          this.schedule.land_settlement_target_date = this.dateArr(this.schedule.land_settlement_target_date);
        }
        if (this.schedule.land_settlement_result_date) {
          this.schedule.land_settlement_result_date = this.dateArr(this.schedule.land_settlement_result_date);
        }
        if (this.schedule.loan_temporary_app_target) {
          this.schedule.loan_temporary_app_target = this.dateArr(this.schedule.loan_temporary_app_target);
        }
        if (this.schedule.loan_temporary_app_actual) {
          this.schedule.loan_temporary_app_actual = this.dateArr(this.schedule.loan_temporary_app_actual);
        }
        if (this.schedule.finance_temporary_app_target) {
          this.schedule.finance_temporary_app_target = this.dateArr(this.schedule.finance_temporary_app_target);
        }
        if (this.schedule.finance_temporary_app_actual) {
          this.schedule.finance_temporary_app_actual = this.dateArr(this.schedule.finance_temporary_app_actual);
        }
        if (this.schedule.finance_application_target_date) {
          this.schedule.finance_application_target_date = this.dateArr(this.schedule.finance_application_target_date);
        }
        if (this.schedule.finance_application_actual_date) {
          this.schedule.finance_application_actual_date = this.dateArr(this.schedule.finance_application_actual_date);
        }
        if (this.schedule.finance_app_target_date) {
          this.schedule.finance_app_target_date = this.dateArr(this.schedule.finance_app_target_date);
        }
        if (this.schedule.finance_app_actual_date) {
          this.schedule.finance_app_actual_date = this.dateArr(this.schedule.finance_app_actual_date);
        }
        if (this.schedule.bridge_loan_land_target) {
          this.schedule.bridge_loan_land_target = this.dateArr(this.schedule.bridge_loan_land_target);
        }
        if (this.schedule.bridge_loan_const_target) {
          this.schedule.bridge_loan_const_target = this.dateArr(this.schedule.bridge_loan_const_target);
        }
        if (this.schedule.bridge_loan_interim_target) {
          this.schedule.bridge_loan_interim_target = this.dateArr(this.schedule.bridge_loan_interim_target);
        }
        if (this.schedule.money_consumpltion_agree_target) {
          this.schedule.money_consumpltion_agree_target = this.dateArr(this.schedule.money_consumpltion_agree_target);
        }
        if (this.schedule.bridge_loan_land) {
          this.schedule.bridge_loan_land = this.dateArr(this.schedule.bridge_loan_land);
        }
        if (this.schedule.bridge_loan_const) {
          this.schedule.bridge_loan_const = this.dateArr(this.schedule.bridge_loan_const);
        }
        if (this.schedule.bridge_loan_interim) {
          this.schedule.bridge_loan_interim = this.dateArr(this.schedule.bridge_loan_interim);
        }
        if (this.schedule.money_consumpltion_agree) {
          this.schedule.money_consumpltion_agree = this.dateArr(this.schedule.money_consumpltion_agree);
        }
        if (this.schedule.ground_survey_request_date_target) {
          this.schedule.ground_survey_request_date_target = this.dateArr(this.schedule.ground_survey_request_date_target);
        }
        if (this.schedule.ground_survey_implement_date_target) {
          this.schedule.ground_survey_implement_date_target = this.dateArr(this.schedule.ground_survey_implement_date_target);
        }
        if (this.schedule.dismantling_start_date_target) {
          this.schedule.dismantling_start_date_target = this.dateArr(this.schedule.dismantling_start_date_target);
        }
        if (this.schedule.dismantling_end_date_target) {
          this.schedule.dismantling_end_date_target = this.dateArr(this.schedule.dismantling_end_date_target);
        }
        if (this.schedule.garden_start_date_target) {
          this.schedule.garden_start_date_target = this.dateArr(this.schedule.garden_start_date_target);
        }
        if (this.schedule.garden_end_date_target) {
          this.schedule.garden_end_date_target = this.dateArr(this.schedule.garden_end_date_target);
        }
        if (this.schedule.ground_improvement_date_target) {
          this.schedule.ground_improvement_date_target = this.dateArr(this.schedule.ground_improvement_date_target);
        }
        if (this.schedule.ground_survey_request_date) {
          this.schedule.ground_survey_request_date = this.dateArr(this.schedule.ground_survey_request_date);
        }
        if (this.schedule.ground_survey_implement_date) {
          this.schedule.ground_survey_implement_date = this.dateArr(this.schedule.ground_survey_implement_date);
        }
        if (this.schedule.dismantling_start_date) {
          this.schedule.dismantling_start_date = this.dateArr(this.schedule.dismantling_start_date);
        }
        if (this.schedule.dismantling_end_date) {
          this.schedule.dismantling_end_date = this.dateArr(this.schedule.dismantling_end_date);
        }
        if (this.schedule.garden_start_date) {
          this.schedule.garden_start_date = this.dateArr(this.schedule.garden_start_date);
        }
        if (this.schedule.garden_end_date) {
          this.schedule.garden_end_date = this.dateArr(this.schedule.garden_end_date);
        }
        if (this.schedule.ground_improvement_date) {
          this.schedule.ground_improvement_date = this.dateArr(this.schedule.ground_improvement_date);
        }
        if (this.schedule.approval_book_get_date_target) {
          this.schedule.approval_book_get_date_target = this.dateArr(this.schedule.approval_book_get_date_target);
        }
        if (this.schedule.four_people_meeting_target) {
          this.schedule.four_people_meeting_target = this.dateArr(this.schedule.four_people_meeting_target);
        }
        if (this.schedule.final_decision_mark_target) {
          this.schedule.final_decision_mark_target = this.dateArr(this.schedule.final_decision_mark_target);
        }
        if (this.schedule.approval_book_get_date) {
          this.schedule.approval_book_get_date = this.dateArr(this.schedule.approval_book_get_date);
        }
        if (this.schedule.four_people_meeting) {
          this.schedule.four_people_meeting = this.dateArr(this.schedule.four_people_meeting);
        }
        if (this.schedule.final_decision_mark) {
          this.schedule.final_decision_mark = this.dateArr(this.schedule.final_decision_mark);
        }
        if (this.schedule.other_resuest_date1_target) {
          this.schedule.other_resuest_date1_target = this.dateArr(this.schedule.other_resuest_date1_target);
        }
        if (this.schedule.other_resuest_date2_target) {
          this.schedule.other_resuest_date2_target = this.dateArr(this.schedule.other_resuest_date2_target);
        }
        if (this.schedule.other_resuest_date3_target) {
          this.schedule.other_resuest_date3_target = this.dateArr(this.schedule.other_resuest_date3_target);
        }
        if (this.schedule.other_resuest_date4_target) {
          this.schedule.other_resuest_date4_target = this.dateArr(this.schedule.other_resuest_date4_target);
        }
        if (this.schedule.other_resuest_approval_date1_target) {
          this.schedule.other_resuest_approval_date1_target = this.dateArr(this.schedule.other_resuest_approval_date1_target);
        }
        if (this.schedule.other_resuest_approval_date2_target) {
          this.schedule.other_resuest_approval_date2_target = this.dateArr(this.schedule.other_resuest_approval_date2_target);
        }
        if (this.schedule.other_resuest_approval_date3_target) {
          this.schedule.other_resuest_approval_date3_target = this.dateArr(this.schedule.other_resuest_approval_date3_target);
        }
        if (this.schedule.other_resuest_approval_date4_target) {
          this.schedule.other_resuest_approval_date4_target = this.dateArr(this.schedule.other_resuest_approval_date4_target);
        }
        if (this.schedule.other_resuest_date1) {
          this.schedule.other_resuest_date1 = this.dateArr(this.schedule.other_resuest_date1);
        }
        if (this.schedule.other_resuest_date2) {
          this.schedule.other_resuest_date2 = this.dateArr(this.schedule.other_resuest_date2);
        }
        if (this.schedule.other_resuest_date3) {
          this.schedule.other_resuest_date3 = this.dateArr(this.schedule.other_resuest_date3);
        }
        if (this.schedule.other_resuest_date4) {
          this.schedule.other_resuest_date4 = this.dateArr(this.schedule.other_resuest_date4);
        }
        if (this.schedule.other_resuest_approval_date1) {
          this.schedule.other_resuest_approval_date1 = this.dateArr(this.schedule.other_resuest_approval_date1);
        }
        if (this.schedule.other_resuest_approval_date2) {
          this.schedule.other_resuest_approval_date2 = this.dateArr(this.schedule.other_resuest_approval_date2);
        }
        if (this.schedule.other_resuest_approval_date3) {
          this.schedule.other_resuest_approval_date3 = this.dateArr(this.schedule.other_resuest_approval_date3);
        }
        if (this.schedule.other_resuest_approval_date4) {
          this.schedule.other_resuest_approval_date4 = this.dateArr(this.schedule.other_resuest_approval_date4);
        }
        if (this.schedule.confirm_resuest_date_target) {
          this.schedule.confirm_resuest_date_target = this.dateArr(this.schedule.confirm_resuest_date_target);
        }
        if (this.schedule.confirm_resuest_approval_date_target) {
          this.schedule.confirm_resuest_approval_date_target = this.dateArr(this.schedule.confirm_resuest_approval_date_target);
        }
        if (this.schedule.confirm_resuest_date) {
          this.schedule.confirm_resuest_date = this.dateArr(this.schedule.confirm_resuest_date);
        }
        if (this.schedule.confirm_resuest_approval_date) {
          this.schedule.confirm_resuest_approval_date = this.dateArr(this.schedule.confirm_resuest_approval_date);
        }
        if (this.schedule.construction_approval_request_target) {
          this.schedule.construction_approval_request_target = this.dateArr(this.schedule.construction_approval_request_target);
        }
        if (this.schedule.construction_approval_request) {
          this.schedule.construction_approval_request = this.dateArr(this.schedule.construction_approval_request);
        }
        if (this.schedule.construction_approval_date) {
          this.schedule.construction_approval_date = this.dateArr(this.schedule.construction_approval_date);
        }
        if (this.schedule.construction_approval_date_target) {
          this.schedule.construction_approval_date_target = this.dateArr(this.schedule.construction_approval_date_target);
        }
        if (this.schedule.construction_payment_plandate) {
          this.schedule.construction_payment_plandate = this.dateArr(this.schedule.construction_payment_plandate);
        }
        if (this.schedule.construction_payment_date) {
          this.schedule.construction_payment_date = this.dateArr(this.schedule.construction_payment_date);
        }
        if (this.schedule.gl_layout_target) {
          this.schedule.gl_layout_target = this.dateArr(this.schedule.gl_layout_target);
        }
        if (this.schedule.ground_prayer_target) {
          this.schedule.ground_prayer_target = this.dateArr(this.schedule.ground_prayer_target);
        }
        if (this.schedule.gl_layout) {
          this.schedule.gl_layout = this.dateArr(this.schedule.gl_layout);
        }
        if (this.schedule.ground_prayer) {
          this.schedule.ground_prayer = this.dateArr(this.schedule.ground_prayer);
        }
        if (this.schedule.ground_prayer_none) {
          this.schedule.ground_prayer_none = (this.schedule.ground_prayer_none == '1');
        }
        if (this.schedule.base_construction_date_target) {
          this.schedule.base_construction_date_target = this.dateArr(this.schedule.base_construction_date_target);
        }
        if (this.schedule.base_construction_date) {
          this.schedule.base_construction_date = this.dateArr(this.schedule.base_construction_date);
        }
        if (this.schedule.midway_payment_plandate) {
          this.schedule.midway_payment_plandate = this.dateArr(this.schedule.midway_payment_plandate);
        }
        if (this.schedule.midway_payment_date) {
          this.schedule.midway_payment_date = this.dateArr(this.schedule.midway_payment_date);
        }
        if (this.schedule.upper_build_date_target) {
          this.schedule.upper_build_date_target = this.dateArr(this.schedule.upper_build_date_target);
        }
        if (this.schedule.outlet_target) {
          this.schedule.outlet_target = this.dateArr(this.schedule.outlet_target);
        }
        if (this.schedule.upper_build_date) {
          this.schedule.upper_build_date = this.dateArr(this.schedule.upper_build_date);
        }
        if (this.schedule.outlet) {
          this.schedule.outlet = this.dateArr(this.schedule.outlet);
        }
        if (this.schedule.midway_check_date_target) {
          this.schedule.midway_check_date_target = this.dateArr(this.schedule.midway_check_date_target);
        }
        if (this.schedule.midway_check_date) {
          this.schedule.midway_check_date = this.dateArr(this.schedule.midway_check_date);
        }
        if (this.schedule.framework_end_date_target) {
          this.schedule.framework_end_date_target = this.dateArr(this.schedule.framework_end_date_target);
        }
        if (this.schedule.company_inspection_date_target) {
          this.schedule.company_inspection_date_target = this.dateArr(this.schedule.company_inspection_date_target);
        }
        if (this.schedule.complete_check_date_target) {
          this.schedule.complete_check_date_target = this.dateArr(this.schedule.complete_check_date_target);
        }
        if (this.schedule.completion_date_target) {
          this.schedule.completion_date_target = this.dateArr(this.schedule.completion_date_target);
        }
        if (this.schedule.framework_end_date) {
          this.schedule.framework_end_date = this.dateArr(this.schedule.framework_end_date);
        }
        if (this.schedule.company_inspection_date) {
          this.schedule.company_inspection_date = this.dateArr(this.schedule.company_inspection_date);
        }
        if (this.schedule.complete_check_date) {
          this.schedule.complete_check_date = this.dateArr(this.schedule.complete_check_date);
        }
        if (this.schedule.completion_date) {
          this.schedule.completion_date = this.dateArr(this.schedule.completion_date);
        }
        if (this.schedule.final_payment_plandate) {
          this.schedule.final_payment_plandate = this.dateArr(this.schedule.final_payment_plandate);
        }
        if (this.schedule.final_payment_date) {
          this.schedule.final_payment_date = this.dateArr(this.schedule.final_payment_date);
        }
        if (this.schedule.complete_visit_start_date_target) {
          this.schedule.complete_visit_start_date_target = this.dateArr(this.schedule.complete_visit_start_date_target);
        }
        if (this.schedule.complete_visit_end_date_target) {
          this.schedule.complete_visit_end_date_target = this.dateArr(this.schedule.complete_visit_end_date_target);
        }
        if (this.schedule.complete_visit_start_date) {
          this.schedule.complete_visit_start_date = this.dateArr(this.schedule.complete_visit_start_date);
        }
        if (this.schedule.complete_visit_end_date) {
          this.schedule.complete_visit_end_date = this.dateArr(this.schedule.complete_visit_end_date);
        }
        if (this.schedule.delivery_date_target) {
          this.schedule.delivery_date_target = this.dateArr(this.schedule.delivery_date_target);
        }
        if (this.schedule.delivery_date) {
          this.schedule.delivery_date = this.dateArr(this.schedule.delivery_date);
        }
        if (this.schedule.after_date1) {
          this.schedule.after_date1 = this.dateArr(this.schedule.after_date1);
        }
        if (this.schedule.after_date2) {
          this.schedule.after_date2 = this.dateArr(this.schedule.after_date2);
        }
        if (this.schedule.after_date3) {
          this.schedule.after_date3 = this.dateArr(this.schedule.after_date3);
        }
        if (this.schedule.after_date1_target) {
          this.schedule.after_date1_target = this.dateArr(this.schedule.after_date1_target);
        }
        if (this.schedule.after_date2_target) {
          this.schedule.after_date2_target = this.dateArr(this.schedule.after_date2_target);
        }
        if (this.schedule.after_date3_target) {
          this.schedule.after_date3_target = this.dateArr(this.schedule.after_date3_target);
        }

        //更新履歴
        let List = this.customerInputService.customerUpdateList(customer_code);
        List.subscribe(List => {
          this.detail_update_list = List;
        });
        this.interview.user_code = this.input.sales_contact_code;
        //面談履歴一覧取得
        let List2 = this.customerInputService.customerInterviewList(customer_code);
        List2.subscribe(List2 => {
          this.detail_interview_list = List2;
        });
        //画像集一覧取得
        let List3 = this.customerInputService.customerImglistList(customer_code);
        List3.subscribe(List3 => {
          this.imglists = List3;
        });
        //注意一覧取得
        let List4 = this.customerInputService.customerNoticeList(customer_code);
        List4.subscribe(List4 => {
          this.noticelists = List4;
        });

        //入金予定
        this.schedulePayment_contract();
        this.schedulePayment_plan();

        this.defaultInputNot();
      });
      this.customerInputService.ip_flg = false;
    } else {
      //新規登録時
      this.tab = "panel1";
      this.customerInputService.ip_flg = true;
      this.input.division_code = this.authService.getDivisionCode();
      this.input.sales_contact_code = this.authService.getUserCode();

      this.interview.title = "初回面談";
      this.interview.uc_status = "予定";

      this.jointNameLength = 0;
    }

    //県・年・月
    this.Prefectures = this.formService.getPrefectures();
    this.years = this.formService.formSetYear(1900);
    this.months = this.formService.formSetMonth();

    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['users'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });

    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
      this.app_place_list = this.place_list.filter(place=>{
        return !place.sold;
      })
    });

  }

  //担当者絞込用
  userList(division_code) {
    /*
    let list = this.customerInputService.customerBase(division_code);
    list.subscribe(list => {
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
    */
  }

  //顧客詳細保存
  customerInput() {

    this.error = "";
    this.formService.tab = this.tab;
    this.formService.active = this.active;

    this.a1.forEach((val, i) => {
      if (this.question.a1[i]) {
        this.question.a1[i] = val;
      }
    });
    this.a3.forEach((val, i) => {
      if (this.question.a3[i]) {
        this.question.a3[i] = val;
      }
    });
    this.a8.forEach((val, i) => {
      if (this.question.a8[i]) {
        this.question.a8[i] = val;
      }
    });

    let res = this.customerInputService.customerInput(this.input, this.question, this.point, this.schedule, this.interview);
    res.subscribe(res => {
      if (res['state'] == "update" || res['state'] == "insert") {
        var id = res['id'];
        if (res['state'] == "update") {
          this.router.navigate(['/detail/' + id]);
          this.message = "顧客情報を更新しました";
          this.error = "";
        } else if (res['state'] == "insert") {
          this.router.navigate(['/detail/' + id]);
          this.input.customer_code = id;

          this.message = "顧客情報を保存しました";
          this.error = "";
          /*
        } else if (res['state'] == "overlap") {
          this.message = "";
          this.error = "";
          this.error_mdl = "スケジュールが重複しています";
          */
        }
        if (res['overlap'] == '1') {
          this.message = this.message + "（スケジュールが重複しています）";
        } else if (res['overlap'] == '2') {
          this.message = this.message + "（スケジュールが重複している人がいます）";
        }
    } else {
        this.message = "更新失敗";
        this.error = "";
      }

    });
  }

  //入力キャンセル
  cancelInput() {
    this.formService.tab = this.tab;
    this.formService.active = this.active;
    this.scService.sc = this.sc;

    const customer_code = +this.route.snapshot.paramMap.get('id');
    if (customer_code) {
      this.router.navigate(['/detail/' + customer_code]);
    } else {
      this.input = this.formService.r_input;
      this.question = this.formService.r_question;
      this.schedule = this.formService.r_schedule;
      this.point = this.formService.r_point;

      this.router.navigate(['/input/']);
    }
  }

  //注意：追加モーダル
  open_na(notice_add) {
    this.notice_ad.notice_user_code = this.input.sales_contact_code;
    this.notice_ad.notice = "";
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(notice_add, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  //注意：編集モーダル
  open_ne(notice_edt, i) {
    this.notice_ed.notice_id = this.noticelists[i].notice_id;
    this.notice_ed.notice_user_code = this.noticelists[i].uesr_code;
    this.notice_ed.notice = this.noticelists[i].notice;
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(notice_edt, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  //注意：削除モーダル
  open_nd(notice_del, i) {
    this.notice_ed.notice_id = this.noticelists[i].notice_id;
    this.notice_ed.notice_user_code = this.noticelists[i].uesr_code;
    this.notice_ed.notice = this.noticelists[i].notice;
    this.notice_ed.del_chk = "";
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(notice_del, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  //注意：追加
  customerNoticeAdd() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerNotice(customer_code, this.notice_ad);
    res.subscribe(res => {
      //更新履歴
      let List = this.customerInputService.customerUpdateList(customer_code);
      List.subscribe(List => {
        this.detail_update_list = List;
      });
      //注意一覧取得
      let List4 = this.customerInputService.customerNoticeList(customer_code);
      List4.subscribe(List4 => {
        this.noticelists = List4;
      });
      //モーダル閉じる
      this.modalReference.close();
    });
  }
  //注意：編集
  customerNoticeEdt() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerNotice(customer_code, this.notice_ed);
    res.subscribe(res => {
      //更新履歴
      let List = this.customerInputService.customerUpdateList(customer_code);
      List.subscribe(List => {
        this.detail_update_list = List;
      });
      //面談履歴一覧取得
      let List2 = this.customerInputService.customerInterviewList(customer_code);
      List2.subscribe(List2 => {
        this.detail_interview_list = List2;
      });
      //注意一覧取得
      let List4 = this.customerInputService.customerNoticeList(customer_code);
      List4.subscribe(List4 => {
        this.noticelists = List4;
      });
      //モーダル閉じる
      this.modalReference.close();
    });
  }
  //注意：削除
  customerNoticeDel() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerNoticeDel(customer_code, this.notice_ed);
    res.subscribe(res => {
      //更新履歴
      let List = this.customerInputService.customerUpdateList(customer_code);
      List.subscribe(List => {
        this.detail_update_list = List;
      });
      //面談履歴一覧取得
      let List2 = this.customerInputService.customerInterviewList(customer_code);
      List2.subscribe(List2 => {
        this.detail_interview_list = List2;
      });
      //注意一覧取得
      let List4 = this.customerInputService.customerNoticeList(customer_code);
      List4.subscribe(List4 => {
        this.noticelists = List4;
      });
      //モーダル閉じる
      this.modalReference.close();
    });
  }

  //画像アップロード用
  upfile: File = null;
  fileChangeEvent(list: any) {
    this.upfile = <File>list[0];
  }
  imgUpload(upfile, filename, directory) {
    let fd = new FormData();
    fd.append('upfile', upfile, filename);
    fd.append('directory', upfile, directory);
    var url = this.srcurl + "upload.php";
    const header = new HttpHeaders({});

    let res = this.httpClient.post(url, fd, { headers: header })
      .subscribe(res => {
      });
  }

  //面談履歴追加
  customerInterview() {
    console.log('customerInterview a');
    const customer_code = +this.route.snapshot.paramMap.get('id');
    if (this.upfile) {
      this.interview.upfile_name = this.upfile.name;
    } else {
      this.interview.upfile_name = null;
    }
    console.log('customerInterview b');
    let res = this.customerInputService.customerInterview(this.interview, customer_code);
    console.log('customerInterview c');
    res.subscribe(res => {
      console.log('customerInterview d');
      if (res['result'] == 'success') {
        this.message = "面談情報を登録しました";
        this.error = "";
        if (this.upfile) {
          var directory = res['customer_code'];//顧客コード
          var ext = this.interview.upfile_name.split('.');
          var filename = "uc_" + res['user_calendar_code'] + "." + ext[1];//スケジュールコード
          this.imgUpload(this.upfile, filename, directory);
        }
        this.ngOnInit();
        this.tab = "panel5";
        //モーダル閉じる
        this.modalReference.close();
        if (this.interview.is_next_app) {
          this.ciiOpen(this.itvw_add);
        }
      /*
      } else if (res['state'] == "overlap") {
        this.message = "";
        this.error = "";
        this.error_mdl = "スケジュールが重複しています";
      */
      } else {
        this.message = "";
        this.error = "更新失敗";
        //モーダル閉じる
        this.modalReference.close();
      }
      console.log('customerInterview e');
      if (res['overlap'] == '1') {
        this.message = this.message + "（スケジュールが重複しています）";
      } else if (res['overlap'] == '2') {
        this.message = this.message + "（スケジュールが重複している人がいます）";
      }
  this.upfile = null;
    });
    console.log('customerInterview f');
  }


  //面談履歴編集
  customerInterviewEdt() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    if (this.upfile) {
      this.interview_edit.upfile_name = this.upfile.name;
      this.interview.upfile_chk = null;
    } else {
      this.interview_edit.upfile_name = null;
    }
    let res = this.customerInputService.customerInterview(this.interview_edit, customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        this.message = "面談情報を更新しました";
        this.error = "";
        if (this.upfile) {
          var directory = res['customer_code'];//顧客コード
          var ext = this.interview_edit.upfile_name.split('.');
          var filename = "uc_" + res['user_calendar_code'] + "." + ext[1];//スケジュールコード
          this.imgUpload(this.upfile, filename, directory);
        }
        this.ngOnInit();
        this.tab = "panel5";
        //モーダル閉じる
        this.modalReference.close();
        if (this.interview_edit.is_next_app) {
          this.ciiOpen(this.itvw_add);
        }
      /*
      } else if (res['state'] == "overlap") {
        this.message = "";
        this.error = "";
        this.error_mdl = "スケジュールが重複しています";
      */
      } else {
        this.message = "";
        this.error = "更新失敗";
        //モーダル閉じる
        this.modalReference.close();
      }
      if (res['overlap'] == '1') {
        this.message = this.message + "（スケジュールが重複しています）";
      } else if (res['overlap'] == '2') {
        this.message = this.message + "（スケジュールが重複している人がいます）";
      }
      this.upfile = null;
    });
  }
  //面談履歴削除
  customerInterviewDel() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerInterviewDel(this.interview_edit, customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        this.message = "面談情報を削除しました";
        this.error = "";
        //更新履歴
        let List = this.customerInputService.customerUpdateList(customer_code);
        List.subscribe(List => {
          this.detail_update_list = List;
        });
        //面談履歴一覧取得
        let List2 = this.customerInputService.customerInterviewList(customer_code);
        List2.subscribe(List2 => {
          this.detail_interview_list = List2;
        });
        //注意一覧取得
        let List4 = this.customerInputService.customerNoticeList(customer_code);
        List4.subscribe(List4 => {
          this.noticelists = List4;
        });
        //モーダル閉じる
        this.modalReference.close();
      } else {
        this.message = "";
        this.error = "削除失敗";
      }
    });
  }

  //面談履歴：画像モーダル
  open_itvw_img(itvw_img, imgname) {
    this.itvw_imgname = imgname;
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalService.open(itvw_img, config).result.then((result) => { }, (reason) => { });
  }

  //面談履歴モーダル:追加
  ciiOpen(itvw_add) {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let fcdc = this.customerInputService.customerFcDoneCheck(customer_code);
    fcdc.subscribe(val => {
      this.fcdc_flg = !(val);
    });
    this.error_mdl = "";
    this.upfile = null;
    this.interview = {};
    this.interview.user_code = this.input.sales_contact_code;
    this.interview.title = "";
    this.interview.place = "";
    this.interview.event_calendar_code = "";
    this.interview.contents = "";
    this.interview.uc_status = "予定";
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg'
    };
    this.modalReference = this.modalService.open(itvw_add, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }

  //面談履歴モーダル：編集・削除
  cieOpen(itvw_edt, i) {
    this.error_mdl = "";
    this.upfile = null;
    this.interview_edit = this.detail_interview_list[i];
    this.interview_edit.date = this.dateArr(this.interview_edit.start_datetime);
    this.interview_edit.start_hour = this.formatDate2(new Date(this.interview_edit.start_datetime), 'hh');
    this.interview_edit.start_minute = this.formatDate2(new Date(this.interview_edit.start_datetime), 'mm');
    this.interview_edit.end_hour = this.formatDate2(new Date(this.interview_edit.end_datetime), 'hh');
    this.interview_edit.end_minute = this.formatDate2(new Date(this.interview_edit.end_datetime), 'mm');
    if (this.interview_edit.upfile) {
      this.interview_edit.upfile_name = this.interview_edit.upfile;
    }
    this.interview_edit.upfile_chk = null;
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(itvw_edt, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }

  imgChk(list: any) {
    this.upfile = <File>list[0];
    if (this.upfile) {
      this.imglist.img_name = this.upfile.name;
    }
  }
  //画像集：登録
  imglistInput() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    if (this.upfile) {
      this.imglist.img_name = this.upfile.name;
    } else {
      //this.imglist.img_name = null;
    }
    let res = this.customerInputService.customerImglistInput(this.imglist, customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        if (res['state'] == 'insert') {
          this.message = "画像を追加しました";
          this.error = "";
          if (this.upfile) {
            var directory = res['customer_code'];
            var ext = this.imglist.img_name.split('.');
            var filename = "il_" + res['imglist_code'] + "." + ext[1];
            this.imgUpload(this.upfile, filename, directory);
          }
        }
        this.imglist = {}
        //モーダル閉じる
        this.modalReference.close();
        //更新履歴
        let List = this.customerInputService.customerUpdateList(customer_code);
        List.subscribe(List => {
          this.detail_update_list = List;
        });
        //画像集一覧取得
        let List3 = this.customerInputService.customerImglistList(customer_code);
        List3.subscribe(List3 => {
          this.imglists = List3;
        });
      } else {
        this.message = "";
        this.error = "追加失敗";
      }
      this.upfile = null;
    });
  }

  //画像集：編集
  imglistEdit() {
    const customer_code = +this.route.snapshot.paramMap.get('id');

    let res = this.customerInputService.customerImglistInput(this.imglist_edt, customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        if (res['state'] !== 'insert') {
          this.message = "画像を編集しました";
          this.error = "";
        }
        //モーダル閉じる
        this.modalReference.close();
        //更新履歴
        let List = this.customerInputService.customerUpdateList(customer_code);
        List.subscribe(List => {
          this.detail_update_list = List;
        });
        //画像集一覧取得
        let List3 = this.customerInputService.customerImglistList(customer_code);
        List3.subscribe(List3 => {
          this.imglists = List3;
        });
      } else {
        this.message = "";
        this.error = "追加失敗";
      }
      this.upfile = null;
    });
  }

  //画像集：削除
  imglistDelete() {
    if (this.imglist_edt.del_chk) {
      //console.log( this.imglist_edt );
    }
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerImglistDel(this.imglist_edt, customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        this.message = "画像を削除しました";
        this.error = "";
        //更新履歴
        let List = this.customerInputService.customerUpdateList(customer_code);
        List.subscribe(List => {
          this.detail_update_list = List;
        });
        //画像集一覧取得
        let List3 = this.customerInputService.customerImglistList(customer_code);
        List3.subscribe(List3 => {
          this.imglists = List3;
        });
        //モーダル閉じる
        this.modalReference.close();
      } else {
        this.message = "";
        this.error = "削除失敗";
      }
    });
  }

  //面像集：登録モーダル
  ilaOpen(il_add) {
    this.imglist.img_name = null;
    this.imglist.img_memo = "";
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(il_add, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }

  //面像集：編集・削除モーダル
  ileOpen(il_edt, i) {
    this.upfile = null;
    this.imglist_edt = this.imglists[i];
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(il_edt, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  //プラン一括変更モーダル
  open_plan(plan_bulk) {
    this.bulk.all_check = false;
    this.bulkDisabled();
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(plan_bulk, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  bulkDisabled() {
    var count = 0;
    if (this.schedule.approval_book_get_date_target) {
      count++;
    }
    if (this.schedule.four_people_meeting_target) {
      count++;
    }
    if (this.schedule.final_decision_mark_target) {
      count++;
    }
    if (this.schedule.approval_book_get_date) {
      count++;
    }
    if (this.schedule.four_people_meeting) {
      count++;
    }
    if (this.schedule.final_decision_mark) {
      count++;
    }
    if (this.schedule.other_resuest_date1_target) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date1_target) {
      count++;
    }
    if (this.schedule.other_resuest_date2_target) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date2_target) {
      count++;
    }
    if (this.schedule.other_resuest_date3_target) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date3_target) {
      count++;
    }
    if (this.schedule.other_resuest_date4_target) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date4_target) {
      count++;
    }
    if (this.schedule.other_resuest_date1) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date1) {
      count++;
    }
    if (this.schedule.other_resuest_date2) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date2) {
      count++;
    }
    if (this.schedule.other_resuest_date3) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date3) {
      count++;
    }
    if (this.schedule.other_resuest_date4) {
      count++;
    }
    if (this.schedule.other_resuest_approval_date4) {
      count++;
    }
    if (this.schedule.confirm_resuest_date_target) {
      count++;
    }
    if (this.schedule.confirm_resuest_approval_date_target) {
      count++;
    }
    if (this.schedule.confirm_resuest_date) {
      count++;
    }
    if (this.schedule.confirm_resuest_approval_date) {
      count++;
    }
    if (this.schedule.construction_approval_request_target) {
      count++;
    }
    if (this.schedule.construction_approval_request) {
      count++;
    }
    if (this.schedule.construction_approval_date) {
      count++;
    }
    if (this.schedule.construction_approval_date_target) {
      count++;
    }
    if (this.schedule.construction_payment_plandate) {
      count++;
    }
    if (this.schedule.construction_payment_date) {
      count++;
    }
    if (this.schedule.gl_layout_target) {
      count++;
    }
    if (this.schedule.ground_prayer_target) {
      count++;
    }
    if (this.schedule.base_construction_date_target) {
      count++;
    }
    if (this.schedule.gl_layout) {
      count++;
    }
    if (this.schedule.ground_prayer) {
      count++;
    }
    if (this.schedule.base_construction_date) {
      count++;
    }
    if (this.schedule.midway_payment_plandate) {
      count++;
    }
    if (this.schedule.midway_payment_date) {
      count++;
    }
    if (this.schedule.upper_build_date_target) {
      count++;
    }
    if (this.schedule.outlet_target) {
      count++;
    }
    if (this.schedule.upper_build_date) {
      count++;
    }
    if (this.schedule.outlet) {
      count++;
    }
    if (this.schedule.midway_check_date_target) {
      count++;
    }
    if (this.schedule.midway_check_date) {
      count++;
    }
    if (this.schedule.framework_end_date_target) {
      count++;
    }
    if (this.schedule.company_inspection_date_target) {
      count++;
    }
    if (this.schedule.complete_check_date_target) {
      count++;
    }
    if (this.schedule.completion_date_target) {
      count++;
    }
    if (this.schedule.framework_end_date) {
      count++;
    }
    if (this.schedule.company_inspection_date) {
      count++;
    }
    if (this.schedule.complete_check_date) {
      count++;
    }
    if (this.schedule.completion_date) {
      count++;
    }
    if (this.schedule.final_payment_plandate) {
      count++;
    }
    if (this.schedule.final_payment_date) {
      count++;
    }
    if (this.schedule.furniture_carryout_start_date) {
      count++;
    }
    if (this.schedule.furniture_carryout_end_date) {
      count++;
    }
    if (this.schedule.furniture_carryout_start_date_target) {
      count++;
    }
    if (this.schedule.furniture_carryout_end_date_target) {
      count++;
    }
    if (this.schedule.complete_visit_start_date_target) {
      count++;
    }
    if (this.schedule.complete_visit_end_date_target) {
      count++;
    }
    if (this.schedule.complete_visit_start_date) {
      count++;
    }
    if (this.schedule.complete_visit_end_date) {
      count++;
    }
    if (this.schedule.delivery_date_target) {
      count++;
    }
    if (this.schedule.delivery_date) {
      count++;
    }
    if (this.schedule.after_date1) {
      count++;
    }
    if (this.schedule.after_date2) {
      count++;
    }
    if (this.schedule.after_date3) {
      count++;
    }
    if (this.schedule.after_date1_target) {
      count++;
    }
    if (this.schedule.after_date2_target) {
      count++;
    }
    if (this.schedule.after_date3_target) {
      count++;
    }

    if (count >= 1) {
      this.bulk.ac_flg = true;
    } else {
      this.bulk.ac_flg = false;
    }
  }
  //全てチェック
  bulkAllCheck() {
    //console.log(this.bulk);
    if (this.bulk.all_check) {
      //全てチェック外す
      this.bulk.approval_book_get_date = false;
      this.bulk.four_people_meeting = false;
      this.bulk.final_decision_mark = false;
      this.bulk.approval_book_get_date_target = false;
      this.bulk.four_people_meeting_target = false;
      this.bulk.final_decision_mark_target = false;
      this.bulk.other_resuest_date1_target = false;
      this.bulk.other_resuest_approval_date1_target = false;
      this.bulk.other_resuest_date2_target = false;
      this.bulk.other_resuest_approval_date2_target = false;
      this.bulk.other_resuest_date3_target = false;
      this.bulk.other_resuest_approval_date3_target = false;
      this.bulk.other_resuest_date4_target = false;
      this.bulk.other_resuest_approval_date4_target = false;
      this.bulk.other_resuest_date1 = false;
      this.bulk.other_resuest_approval_date1 = false;
      this.bulk.other_resuest_date2 = false;
      this.bulk.other_resuest_approval_date2 = false;
      this.bulk.other_resuest_date3 = false;
      this.bulk.other_resuest_approval_date3 = false;
      this.bulk.other_resuest_date4 = false;
      this.bulk.other_resuest_approval_date4 = false;
      this.bulk.confirm_resuest_date_target = false;
      this.bulk.confirm_resuest_approval_date_target = false;
      this.bulk.confirm_resuest_date = false;
      this.bulk.confirm_resuest_approval_date = false;
      this.bulk.construction_approval_request = false;
      this.bulk.construction_approval_request_target = false;
      this.bulk.construction_approval_date = false;
      this.bulk.construction_approval_date_target = false;
      this.bulk.construction_payment_plandate = false;
      this.bulk.construction_payment_date = false;
      this.bulk.gl_layout_target = false;
      this.bulk.ground_prayer_target = false;
      this.bulk.base_construction_date_target = false;
      this.bulk.gl_layout = false;
      this.bulk.ground_prayer = false;
      this.bulk.base_construction_date = false;
      this.bulk.midway_payment_plandate = false;
      this.bulk.midway_payment_date = false;
      this.bulk.upper_build_date_target = false;
      this.bulk.outlet_target = false;
      this.bulk.upper_build_date = false;
      this.bulk.outlet = false;
      this.bulk.midway_check_date_target = false;
      this.bulk.midway_check_date = false;
      this.bulk.framework_end_date_target = false;
      this.bulk.company_inspection_date_target = false;
      this.bulk.complete_check_date_target = false;
      this.bulk.completion_date_target = false;
      this.bulk.framework_end_date = false;
      this.bulk.company_inspection_date = false;
      this.bulk.complete_check_date = false;
      this.bulk.completion_date = false;
      this.bulk.final_payment_plandate = false;
      this.bulk.final_payment_date = false;
      this.bulk.furniture_carryout_start_date = false;
      this.bulk.furniture_carryout_end_date = false;
      this.bulk.furniture_carryout_start_date_target = false;
      this.bulk.furniture_carryout_end_date_target = false;
      this.bulk.complete_visit_start_date_target = false;
      this.bulk.complete_visit_end_date_target = false;
      this.bulk.complete_visit_start_date = false;
      this.bulk.complete_visit_end_date = false;
      this.bulk.delivery_date = false;
      this.bulk.delivery_date_target = false;
      this.bulk.after_date1 = false;
      this.bulk.after_date2 = false;
      this.bulk.after_date3 = false;
      this.bulk.after_date1_target = false;
      this.bulk.after_date2_target = false;
      this.bulk.after_date3_target = false;
      this.bulkDisabled();
    } else {
      //全てチェック
      this.bulk.approval_book_get_date = true;
      this.bulk.four_people_meeting = true;
      this.bulk.final_decision_mark = true;
      this.bulk.approval_book_get_date_target = true;
      this.bulk.four_people_meeting_target = true;
      this.bulk.final_decision_mark_target = true;
      this.bulk.other_resuest_date1_target = true;
      this.bulk.other_resuest_approval_date1_target = true;
      this.bulk.other_resuest_date2_target = true;
      this.bulk.other_resuest_approval_date2_target = true;
      this.bulk.other_resuest_date3_target = true;
      this.bulk.other_resuest_approval_date3_target = true;
      this.bulk.other_resuest_date4_target = true;
      this.bulk.other_resuest_approval_date4_target = true;
      this.bulk.other_resuest_date1 = true;
      this.bulk.other_resuest_approval_date1 = true;
      this.bulk.other_resuest_date2 = true;
      this.bulk.other_resuest_approval_date2 = true;
      this.bulk.other_resuest_date3 = true;
      this.bulk.other_resuest_approval_date3 = true;
      this.bulk.other_resuest_date4 = true;
      this.bulk.other_resuest_approval_date4 = true;
      this.bulk.confirm_resuest_date_target = true;
      this.bulk.confirm_resuest_approval_date_target = true;
      this.bulk.confirm_resuest_date = true;
      this.bulk.confirm_resuest_approval_date = true;
      this.bulk.construction_approval_request = true;
      this.bulk.construction_approval_request_target = true;
      this.bulk.construction_approval_date = true;
      this.bulk.construction_approval_date_target = true;
      this.bulk.construction_payment_plandate = true;
      this.bulk.construction_payment_date = true;
      this.bulk.gl_layout_target = true;
      this.bulk.ground_prayer_target = true;
      this.bulk.base_construction_date_target = true;
      this.bulk.gl_layout = true;
      this.bulk.ground_prayer = true;
      this.bulk.base_construction_date = true;
      this.bulk.midway_payment_plandate = true;
      this.bulk.midway_payment_date = true;
      this.bulk.upper_build_date_target = true;
      this.bulk.outlet_target = true;
      this.bulk.upper_build_date = true;
      this.bulk.outlet = true;
      this.bulk.midway_check_date_target = true;
      this.bulk.midway_check_date = true;
      this.bulk.framework_end_date_target = true;
      this.bulk.company_inspection_date_target = true;
      this.bulk.complete_check_date_target = true;
      this.bulk.completion_date_target = true;
      this.bulk.framework_end_date = true;
      this.bulk.company_inspection_date = true;
      this.bulk.complete_check_date = true;
      this.bulk.completion_date = true;
      this.bulk.final_payment_plandate = true;
      this.bulk.final_payment_date = true;
      this.bulk.furniture_carryout_start_date = true;
      this.bulk.furniture_carryout_end_date = true;
      this.bulk.furniture_carryout_start_date_target = true;
      this.bulk.furniture_carryout_end_date_target = true;
      this.bulk.complete_visit_start_date_target = true;
      this.bulk.complete_visit_end_date_target = true;
      this.bulk.complete_visit_start_date = true;
      this.bulk.complete_visit_end_date = true;
      this.bulk.delivery_date = true;
      this.bulk.delivery_date_target = true;
      this.bulk.after_date1 = true;
      this.bulk.after_date2 = true;
      this.bulk.after_date3 = true;
      this.bulk.after_date1_target = true;
      this.bulk.after_date2_target = true;
      this.bulk.after_date3_target = true;
      this.bulkDisabled();
    }
  }

  //プラン一括変更
  bulkAdd() {
    if (this.bulk.approval_book_get_date && this.schedule.approval_book_get_date) {
      this.schedule.approval_book_get_date = this.dateAdd(this.schedule.approval_book_get_date);
    }
    if (this.bulk.four_people_meeting && this.schedule.four_people_meeting) {
      this.schedule.four_people_meeting = this.dateAdd(this.schedule.four_people_meeting);
    }
    if (this.bulk.final_decision_mark && this.schedule.final_decision_mark) {
      this.schedule.final_decision_mark = this.dateAdd(this.schedule.final_decision_mark);
    }
    if (this.bulk.approval_book_get_date_target && this.schedule.approval_book_get_date_target) {
      this.schedule.approval_book_get_date_target = this.dateAdd(this.schedule.approval_book_get_date_target);
    }
    if (this.bulk.four_people_meeting_target && this.schedule.four_people_meeting_target) {
      this.schedule.four_people_meeting_target = this.dateAdd(this.schedule.four_people_meeting_target);
    }
    if (this.bulk.final_decision_mark_target && this.schedule.final_decision_mark_target) {
      this.schedule.final_decision_mark_target = this.dateAdd(this.schedule.final_decision_mark_target);
    }
    if (this.bulk.other_resuest_date1_target && this.schedule.other_resuest_date1_target) {
      this.schedule.other_resuest_date1_target = this.dateAdd(this.schedule.other_resuest_date1_target);
    }
    if (this.bulk.other_resuest_approval_date1_target && this.schedule.other_resuest_approval_date1_target) {
      this.schedule.other_resuest_approval_date1_target = this.dateAdd(this.schedule.other_resuest_approval_date1_target);
    }
    if (this.bulk.other_resuest_date2_target && this.schedule.other_resuest_date2_target) {
      this.schedule.other_resuest_date2_target = this.dateAdd(this.schedule.other_resuest_date2_target);
    }
    if (this.bulk.other_resuest_approval_date2_target && this.schedule.other_resuest_approval_date2_target) {
      this.schedule.other_resuest_approval_date2_target = this.dateAdd(this.schedule.other_resuest_approval_date2_target);
    }
    if (this.bulk.other_resuest_date3_target && this.schedule.other_resuest_date3_target) {
      this.schedule.other_resuest_date3_target = this.dateAdd(this.schedule.other_resuest_date3_target);
    }
    if (this.bulk.other_resuest_approval_date3_target && this.schedule.other_resuest_approval_date3_target) {
      this.schedule.other_resuest_approval_date3_target = this.dateAdd(this.schedule.other_resuest_approval_date3_target);
    }
    if (this.bulk.other_resuest_date4_target && this.schedule.other_resuest_date4_target) {
      this.schedule.other_resuest_date4_target = this.dateAdd(this.schedule.other_resuest_date4_target);
    }
    if (this.bulk.other_resuest_approval_date4_target && this.schedule.other_resuest_approval_date4_target) {
      this.schedule.other_resuest_approval_date4_target = this.dateAdd(this.schedule.other_resuest_approval_date4_target);
    }
    if (this.bulk.other_resuest_date1 && this.schedule.other_resuest_date1) {
      this.schedule.other_resuest_date1 = this.dateAdd(this.schedule.other_resuest_date1);
    }
    if (this.bulk.other_resuest_approval_date1 && this.schedule.other_resuest_approval_date1) {
      this.schedule.other_resuest_approval_date1 = this.dateAdd(this.schedule.other_resuest_approval_date1);
    }
    if (this.bulk.other_resuest_date2 && this.schedule.other_resuest_date2) {
      this.schedule.other_resuest_date2 = this.dateAdd(this.schedule.other_resuest_date2);
    }
    if (this.bulk.other_resuest_approval_date2 && this.schedule.other_resuest_approval_date2) {
      this.schedule.other_resuest_approval_date2 = this.dateAdd(this.schedule.other_resuest_approval_date2);
    }
    if (this.bulk.other_resuest_date3 && this.schedule.other_resuest_date3) {
      this.schedule.other_resuest_date3 = this.dateAdd(this.schedule.other_resuest_date3);
    }
    if (this.bulk.other_resuest_approval_date3 && this.schedule.other_resuest_approval_date3) {
      this.schedule.other_resuest_approval_date3 = this.dateAdd(this.schedule.other_resuest_approval_date3);
    }
    if (this.bulk.other_resuest_date4 && this.schedule.other_resuest_date4) {
      this.schedule.other_resuest_date4 = this.dateAdd(this.schedule.other_resuest_date4);
    }
    if (this.bulk.other_resuest_approval_date4 && this.schedule.other_resuest_approval_date4) {
      this.schedule.other_resuest_approval_date4 = this.dateAdd(this.schedule.other_resuest_approval_date4);
    }
    if (this.bulk.confirm_resuest_date_target && this.schedule.confirm_resuest_date_target) {
      this.schedule.confirm_resuest_date_target = this.dateAdd(this.schedule.confirm_resuest_date_target);
    }
    if (this.bulk.confirm_resuest_approval_date_target && this.schedule.confirm_resuest_approval_date_target) {
      this.schedule.confirm_resuest_approval_date_target = this.dateAdd(this.schedule.confirm_resuest_approval_date_target);
    }
    if (this.bulk.confirm_resuest_date && this.schedule.confirm_resuest_date) {
      this.schedule.confirm_resuest_date = this.dateAdd(this.schedule.confirm_resuest_date);
    }
    if (this.bulk.confirm_resuest_approval_date && this.schedule.confirm_resuest_approval_date) {
      this.schedule.confirm_resuest_approval_date = this.dateAdd(this.schedule.confirm_resuest_approval_date);
    }
    if (this.bulk.construction_approval_request && this.schedule.construction_approval_request) {
      this.schedule.construction_approval_request = this.dateAdd(this.schedule.construction_approval_request);
    }
    if (this.bulk.construction_approval_request_target && this.schedule.construction_approval_request_target) {
      this.schedule.construction_approval_request_target = this.dateAdd(this.schedule.construction_approval_request_target);
    }
    if (this.bulk.construction_approval_date && this.schedule.construction_approval_date) {
      this.schedule.construction_approval_date = this.dateAdd(this.schedule.construction_approval_date);
    }
    if (this.bulk.construction_approval_date_target && this.schedule.construction_approval_date_target) {
      this.schedule.construction_approval_date_target = this.dateAdd(this.schedule.construction_approval_date_target);
    }
    if (this.bulk.construction_payment_plandate && this.schedule.construction_payment_plandate) {
      this.schedule.construction_payment_plandate = this.dateAdd(this.schedule.construction_payment_plandate);
    }
    if (this.bulk.construction_payment_date && this.schedule.construction_payment_date) {
      this.schedule.construction_payment_date = this.dateAdd(this.schedule.construction_payment_date);
    }
    if (this.bulk.gl_layout_target && this.schedule.gl_layout_target) {
      this.schedule.gl_layout_target = this.dateAdd(this.schedule.gl_layout_target);
    }
    if (this.bulk.ground_prayer_target && this.schedule.ground_prayer_target) {
      this.schedule.ground_prayer_target = this.dateAdd(this.schedule.ground_prayer_target);
    }
    if (this.bulk.base_construction_date_target && this.schedule.base_construction_date_target) {
      this.schedule.base_construction_date_target = this.dateAdd(this.schedule.base_construction_date_target);
    }
    if (this.bulk.gl_layout && this.schedule.gl_layout) {
      this.schedule.gl_layout = this.dateAdd(this.schedule.gl_layout);
    }
    if (this.bulk.ground_prayer && this.schedule.ground_prayer) {
      this.schedule.ground_prayer = this.dateAdd(this.schedule.ground_prayer);
    }
    if (this.bulk.base_construction_date && this.schedule.base_construction_date) {
      this.schedule.base_construction_date = this.dateAdd(this.schedule.base_construction_date);
    }
    if (this.bulk.midway_payment_plandate && this.schedule.midway_payment_plandate) {
      this.schedule.midway_payment_plandate = this.dateAdd(this.schedule.midway_payment_plandate);
    }
    if (this.bulk.midway_payment_date && this.schedule.midway_payment_date) {
      this.schedule.midway_payment_date = this.dateAdd(this.schedule.midway_payment_date);
    }
    if (this.bulk.upper_build_date_target && this.schedule.upper_build_date_target) {
      this.schedule.upper_build_date_target = this.dateAdd(this.schedule.upper_build_date_target);
    }
    if (this.bulk.outlet_target && this.schedule.outlet_target) {
      this.schedule.outlet_target = this.dateAdd(this.schedule.outlet_target);
    }
    if (this.bulk.upper_build_date && this.schedule.upper_build_date) {
      this.schedule.upper_build_date = this.dateAdd(this.schedule.upper_build_date);
    }
    if (this.bulk.outlet && this.schedule.outlet) {
      this.schedule.outlet = this.dateAdd(this.schedule.outlet);
    }
    if (this.bulk.midway_check_date_target && this.schedule.midway_check_date_target) {
      this.schedule.midway_check_date_target = this.dateAdd(this.schedule.midway_check_date_target);
    }
    if (this.bulk.midway_check_date && this.schedule.midway_check_date) {
      this.schedule.midway_check_date = this.dateAdd(this.schedule.midway_check_date);
    }
    if (this.bulk.framework_end_date_target && this.schedule.framework_end_date_target) {
      this.schedule.framework_end_date_target = this.dateAdd(this.schedule.framework_end_date_target);
    }
    if (this.bulk.company_inspection_date_target && this.schedule.company_inspection_date_target) {
      this.schedule.company_inspection_date_target = this.dateAdd(this.schedule.company_inspection_date_target);
    }
    if (this.bulk.complete_check_date_target && this.schedule.complete_check_date_target) {
      this.schedule.complete_check_date_target = this.dateAdd(this.schedule.complete_check_date_target);
    }
    if (this.bulk.completion_date_target && this.schedule.completion_date_target) {
      this.schedule.completion_date_target = this.dateAdd(this.schedule.completion_date_target);
    }
    if (this.bulk.framework_end_date && this.schedule.framework_end_date) {
      this.schedule.framework_end_date = this.dateAdd(this.schedule.framework_end_date);
    }
    if (this.bulk.company_inspection_date && this.schedule.company_inspection_date) {
      this.schedule.company_inspection_date = this.dateAdd(this.schedule.company_inspection_date);
    }
    if (this.bulk.complete_check_date && this.schedule.complete_check_date) {
      this.schedule.complete_check_date = this.dateAdd(this.schedule.complete_check_date);
    }
    if (this.bulk.completion_date && this.schedule.completion_date) {
      this.schedule.completion_date = this.dateAdd(this.schedule.completion_date);
    }
    if (this.bulk.final_payment_plandate && this.schedule.final_payment_plandate) {
      this.schedule.final_payment_plandate = this.dateAdd(this.schedule.final_payment_plandate);
    }
    if (this.bulk.final_payment_date && this.schedule.final_payment_date) {
      this.schedule.final_payment_date = this.dateAdd(this.schedule.final_payment_date);
    }
    if (this.bulk.furniture_carryout_start_date_target && this.schedule.furniture_carryout_start_date_target) {
      this.schedule.furniture_carryout_start_date_target = this.dateAdd(this.schedule.furniture_carryout_start_date_target);
    }
    if (this.bulk.furniture_carryout_end_date_target && this.schedule.furniture_carryout_end_date_target) {
      this.schedule.furniture_carryout_end_date_target = this.dateAdd(this.schedule.furniture_carryout_end_date_target);
    }
    if (this.bulk.furniture_carryout_start_date && this.schedule.furniture_carryout_start_date) {
      this.schedule.furniture_carryout_start_date = this.dateAdd(this.schedule.furniture_carryout_start_date);
    }
    if (this.bulk.furniture_carryout_end_date && this.schedule.furniture_carryout_end_date) {
      this.schedule.furniture_carryout_end_date = this.dateAdd(this.schedule.furniture_carryout_end_date);
    }
    if (this.bulk.complete_visit_start_date_target && this.schedule.complete_visit_start_date_target) {
      this.schedule.complete_visit_start_date_target = this.dateAdd(this.schedule.complete_visit_start_date_target);
    }
    if (this.bulk.complete_visit_end_date_target && this.schedule.complete_visit_end_date_target) {
      this.schedule.complete_visit_end_date_target = this.dateAdd(this.schedule.complete_visit_end_date_target);
    }
    if (this.bulk.complete_visit_start_date && this.schedule.complete_visit_start_date) {
      this.schedule.complete_visit_start_date = this.dateAdd(this.schedule.complete_visit_start_date);
    }
    if (this.bulk.complete_visit_end_date && this.schedule.complete_visit_end_date) {
      this.schedule.complete_visit_end_date = this.dateAdd(this.schedule.complete_visit_end_date);
    }
    if (this.bulk.delivery_date && this.schedule.delivery_date) {
      this.schedule.delivery_date = this.dateAdd(this.schedule.delivery_date);
    }
    if (this.bulk.delivery_date_target && this.schedule.delivery_date_target) {
      this.schedule.delivery_date_target = this.dateAdd(this.schedule.delivery_date_target);
    }
    if (this.bulk.after_date1 && this.schedule.after_date1) {
      this.schedule.after_date1 = this.dateAdd(this.schedule.after_date1);
    }
    if (this.bulk.after_date2 && this.schedule.after_date2) {
      this.schedule.after_date2 = this.dateAdd(this.schedule.after_date2);
    }
    if (this.bulk.after_date3 && this.schedule.after_date3) {
      this.schedule.after_date3 = this.dateAdd(this.schedule.after_date3);
    }
    if (this.bulk.after_date1_target && this.schedule.after_date1_target) {
      this.schedule.after_date1_target = this.dateAdd(this.schedule.after_date1_target);
    }
    if (this.bulk.after_date2_target && this.schedule.after_date2_target) {
      this.schedule.after_date2_target = this.dateAdd(this.schedule.after_date2_target);
    }
    if (this.bulk.after_date3_target && this.schedule.after_date3_target) {
      this.schedule.after_date3_target = this.dateAdd(this.schedule.after_date3_target);
    }

    //モーダル閉じる
    this.modalReference.close();

    //値リセット
    //this.bulk = {add_day : 0, ac_flg: false};
    //this.bulk.add_day = 0;
    this.active = "static-5";
  }
  //日数一括加算
  dateAdd(date) {
    var add = new Date(date.year, date.month - 1, date.day);
    add.setDate(add.getDate() + this.bulk.add_day);

    var res = {
      year: parseInt(this.formatDate1(add, 'yyyy')),
      month: parseInt(this.formatDate1(add, 'M')),
      day: parseInt(this.formatDate1(add, 'd')),
    }
    return res;
  }

  //新規登録時：初回面談入力チェック
  fsiCheck() {
    if (
      (this.interview.date && (!this.interview.start_hour || !this.interview.start_minute || !this.interview.end_hour || !this.interview.end_minute || !this.interview.user_code)) ||
      (this.interview.start_hour && (!this.interview.date || !this.interview.start_minute || !this.interview.end_hour || !this.interview.end_minute || !this.interview.user_code)) ||
      (this.interview.start_minute && (!this.interview.date || !this.interview.start_hour || !this.interview.end_hour || !this.interview.end_minute || !this.interview.user_code)) ||
      (this.interview.end_hour && (!this.interview.date || !this.interview.start_hour || !this.interview.start_minute || !this.interview.end_minute || !this.interview.user_code)) ||
      (this.interview.end_minute && (!this.interview.date || !this.interview.start_hour || !this.interview.start_minute || !this.interview.end_hour || !this.interview.user_code)) ||
      (this.interview.user_code && (!this.interview.date || !this.interview.start_hour || !this.interview.start_minute || !this.interview.end_hour || !this.interview.end_minute))
    ) {
      this.fsi_flg = true;
    } else {
      this.fsi_flg = false;
    }
  }
  //サポーター追加判定
  supporterAdd() {
    if (this.interview.support_flg) {
      this.interview.support_flg = false;
    } else {
      this.interview.support_flg = true;
    }
  }
  //サポーター追加判定
  supporterEdt() {
    if (this.interview_edit.support_flg) {
      this.interview_edit.support_flg = false;
    } else {
      this.interview_edit.support_flg = true;
    }
  }

  //面談用時間絞込(新規・追加)
  ftTimeSet() {
    //時
    if (this.interview.start_hour) {
      this.ft_setHour = this.interview.start_hour;
      if (!this.interview.start_minute) {
        this.interview.start_minute = '0';
      }
    }

    //分
    if (this.interview.end_hour) {
      if (this.interview.end_hour == this.ft_setHour) {
        if (this.interview.start_minute == '45') {
          this.ft_setMinute = 0;
          this.interview.end_hour = '' + (parseInt(this.interview.end_hour, 10) + 1);
          this.interview.end_minute = '0';
        } else {
          this.ft_setMinute = parseInt(this.interview.start_minute, 10) + 1;
          if (!this.interview.end_minute || this.ft_setMinute > this.interview.end_minute) {
            if (this.ft_setMinute == 1) {
              this.interview.end_minute = '15';
            } else if (this.ft_setMinute == 16) {
              this.interview.end_minute = '30';
            } else if (this.ft_setMinute == 31) {
              this.interview.end_minute = '45';
            }
          }
        }
      } else {
        this.ft_setMinute = 0;
        if (!this.interview.end_minute) {
          this.interview.end_minute = '0';
        }
      }
    }


    if (this.interview.start_minute) {
      if (this.interview.start_minute == '45') {
        this.ft_setHour = parseInt(this.interview.start_hour, 10) + 1;
      }
    }
  }

  //面談用時間絞込(新規・追加)
  edTimeSet() {
    //時
    if (this.interview_edit.start_hour) {
      this.ed_setHour = this.interview_edit.start_hour;
      if (!this.interview_edit.start_minute) {
        this.interview_edit.start_minute = '0';
      }
    }

    //分
    if (this.interview_edit.end_hour) {
      if (this.interview_edit.end_hour == this.ed_setHour) {
        if (this.interview_edit.start_minute == '45') {
          this.ed_setMinute = 0;
          this.interview_edit.end_hour = '' + (parseInt(this.interview_edit.end_hour, 10) + 1);
          this.interview_edit.end_minute = '0';
        } else {
          this.ed_setMinute = parseInt(this.interview_edit.start_minute, 10) + 1;
          if (!this.interview_edit.end_minute || this.ft_setMinute > parseInt(this.interview_edit.end_minute, 10)) {
            if (this.ft_setMinute == 1) {
              this.interview_edit.end_minute = '15';
            } else if (this.ft_setMinute == 16) {
              this.interview_edit.end_minute = '30';
            } else if (this.ft_setMinute == 31) {
              this.interview_edit.end_minute = '45';
            }
          }
        }
      } else {
        this.ed_setMinute = 0;
        if (!this.interview_edit.end_minute) {
          this.interview_edit.end_minute = '0';
        }
      }
    }

    if (this.interview_edit.start_minute) {
      if (this.interview_edit.start_minute == '45') {
        this.ed_setHour = parseInt(this.interview_edit.start_hour, 10) + 1;
      }
    }

  }

  //見込粗利計算用
  prospectCal() {
    this.point.expected_gross_margin = this.point.contract_amount - this.point.prospective_sales;
  }


  //契約金・追加契約金
  schedulePayment_contract() {
    //合計契約金算出
    if (this.schedule.contract_payment && this.schedule.contract_payment_add) {
      this.schedule.contract_payment_sum = parseInt(this.schedule.contract_payment, 10) + parseInt(this.schedule.contract_payment_add, 10);
    } else {
      if (this.schedule.contract_payment_add) {
        this.schedule.contract_payment_sum = this.schedule.contract_payment_add;
      } else {
        this.schedule.contract_payment_sum = this.schedule.contract_payment;
      }
    }
    if (this.schedule.contract_payment_sum) {
      //予定金額：着工・中間・最終(引渡) -> 切り捨て
      if (!this.schedule.construction_payment_plan) {
        this.schedule.construction_payment_plan = Math.floor(this.schedule.contract_payment_sum / 10 * 4);
      }
      if (!this.schedule.midway_payment_plan) {
        this.schedule.midway_payment_plan = Math.floor(this.schedule.contract_payment_sum / 10 * 3);
      }
      if (!this.schedule.final_payment_plan) {
        this.schedule.final_payment_plan = this.schedule.contract_payment_sum - this.schedule.construction_payment_plan - this.schedule.midway_payment_plan;
      }
    }
  }

  //入金取得用
  schedulePayment_plan() {
    this.tm_pay_p = 0;
    this.tm_pay_name_p = "";
    this.tm_pay_c = 0;
    this.tm_pay_name_c = "";
    this.nm_pay_p = 0;
    this.nm_pay_name_p = "";
    this.nm_pay_c = 0;
    this.nm_pay_name_c = "";
    var count_t_p = 0;
    var count_t_c = 0;
    var count_n_p = 0;
    var count_n_c = 0;
    let now_date = new Date();
    let now_year = now_date.getFullYear();
    let now_month = now_date.getMonth() + 1;
    let next_date = new Date();
    next_date.setMonth(next_date.getMonth() + 2);
    let next_year = next_date.getFullYear();
    let next_month = next_date.getMonth();

    //今月
    if (this.schedule.construction_payment_date && this.schedule.construction_payment) {
      //着工金：入金
      if (this.schedule.construction_payment_date['year'] === now_year && this.schedule.construction_payment_date['month'] === now_month) {
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.construction_payment, 10);
        this.tm_pay_name_c += "着工金";
        count_t_c++;
      }
    } else {
      //着工金：予定
      if (this.schedule.construction_payment_plandate && this.schedule.construction_payment_plandate['year'] === now_year && this.schedule.construction_payment_plandate['month'] === now_month) {
        if (this.schedule.construction_payment_plan) {
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.construction_payment_plan, 10);
          this.tm_pay_name_p += "着工金";
          count_t_p++;
        }
      }
    }

    if (this.schedule.midway_payment_date && this.schedule.midway_payment) {
      //中間金：入金
      if (this.schedule.midway_payment_date['year'] === now_year && this.schedule.midway_payment_date['month'] === now_month) {
        if (count_t_c > 0) {
          this.tm_pay_name_c += "/";
        }
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.midway_payment, 10);
        this.tm_pay_name_c += "中間金";
        count_t_c++;
      }
    } else {
      //中間金：予定
      if (this.schedule.midway_payment_plandate && this.schedule.midway_payment_plandate['year'] === now_year && this.schedule.midway_payment_plandate['month'] === now_month) {
        if (this.schedule.midway_payment_plan) {
          if (count_t_p > 0) {
            this.tm_pay_name_p += "/";
          }
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.midway_payment_plan, 10);
          this.tm_pay_name_p += "中間金";
          count_t_p++;
        }
      }
    }

    if (this.schedule.final_payment_date && this.schedule.final_payment) {
      //最終金：入金
      if (this.schedule.final_payment_date['year'] === now_year && this.schedule.final_payment_date['month'] === now_month) {
        if (count_t_c > 0) {
          this.tm_pay_name_c += "/";
        }
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.final_payment, 10);
        this.tm_pay_name_c += "最終金";
        count_t_c++;
      }
    } else {
      //最終金(引渡金)：予定
      if (this.schedule.final_payment_plandate && this.schedule.final_payment_plandate['year'] === now_year && this.schedule.final_payment_plandate['month'] === now_month) {
        if (this.schedule.final_payment_plan) {
          if (count_t_p > 0) {
            this.tm_pay_name_p += "/";
          }
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.final_payment_plan, 10);
          this.tm_pay_name_p += "最終金";
          count_t_p++;
        }
      }
    }

    //来月
    if (this.schedule.construction_payment_date && this.schedule.construction_payment) {
      //着工金：入金
      if (this.schedule.construction_payment_date['year'] === next_year && this.schedule.construction_payment_date['month'] === next_month) {
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.construction_payment, 10);
        this.nm_pay_name_c += "着工金";
        count_n_c++;
      }
    } else {
      //着工金：予定
      if (this.schedule.construction_payment_plandate && this.schedule.construction_payment_plandate['year'] === next_year && this.schedule.construction_payment_plandate['month'] === next_month) {
        if (this.schedule.construction_payment_plan) {
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.construction_payment_plan, 10);
          this.nm_pay_name_p += "着工金";
          count_n_p++;
        }
      }
    }

    if (this.schedule.midway_payment_date && this.schedule.midway_payment) {
      //中間金：入金
      if (this.schedule.midway_payment_date['year'] === next_year && this.schedule.midway_payment_date['month'] === next_month) {
        if (count_n_c > 0) {
          this.nm_pay_name_c += "/";
        }
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.midway_payment, 10);
        this.nm_pay_name_c += "中間金";
        count_n_c++;
      }
    } else {
      //中間金：予定
      if (this.schedule.midway_payment_plandate && this.schedule.midway_payment_plandate['year'] === next_year && this.schedule.midway_payment_plandate['month'] === next_month) {
        if (this.schedule.midway_payment_plan) {
          if (count_n_p > 0) {
            this.nm_pay_name_p += "/";
          }
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.midway_payment_plan, 10);
          this.nm_pay_name_p += "中間金";
          count_n_p++;
        }
      }
    }

    if (this.schedule.final_payment_date && this.schedule.final_payment) {
      //最終金：入金
      if (this.schedule.final_payment_date['year'] === next_year && this.schedule.final_payment_date['month'] === next_month) {
        if (count_n_c > 0) {
          this.nm_pay_name_c += "/";
        }
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.final_payment, 10);
        this.nm_pay_name_c += "最終金";
        count_n_c++;
      }
    } else {
      //最終金(引渡金)：予定
      if (this.schedule.final_payment_plandate && this.schedule.final_payment_plandate['year'] === next_year && this.schedule.final_payment_plandate['month'] === next_month) {
        if (this.schedule.final_payment_plan) {
          if (count_n_p > 0) {
            this.nm_pay_name_p += "/";
          }
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.final_payment_plan, 10);
          this.nm_pay_name_p += "最終金";
          count_n_p++;
        }
      }
    }
  }

  //ポイント・ランキング変動用
  pointCount() {
    //ポイント計算用
    this.point.total_points = 0;
    this.point.land_points = 0;
    this.point.capital_points = 0;
    this.point.plan_points = 0;
    this.point.conflict_points = 0;
    this.point.affected_points = 0;
    this.point.time_points = 0;
    this.point.visit_points = 0;
    this.point.opertor_points = 0;
    this.point.app_poins = 0;

    if (this.point.land_owner == '有') {
      this.point.land_points++;
    }
    if (this.point.land_owner !== '有') {
      if (this.point.land_buying == '済' || this.point.land_buying == '不要') {
        this.point.land_points++;
      }
    }
    if (this.point.land_lord_consent == '済' || this.point.land_lord_consent == '不要') {
      this.point.land_points++;
    }
    if (this.point.land_public_figure == '済' || this.point.land_public_figure == '不要') {
      this.point.land_points++;
    }
    if (this.point.land_transcript_land == '無' || this.point.land_transcript_land == '済') {
      this.point.land_points++;
    }
    if (this.point.land_transcript_build == '無' || this.point.land_transcript_build == '済') {
      this.point.land_points++;
    }
    if (this.point.land_survey_land == '無' || this.point.land_survey_land == '済') {
      this.point.land_points++;
    }
    if (this.point.land_survey_build == '無' || this.point.land_survey_build == '済') {
      this.point.land_points++;
    }
    if (this.point.land_survey == '済') {
      this.point.land_points++;
    }

    if (this.point.land_dismantling == '有' || this.point.land_dismantling == '無') {
      this.point.land_points++;
    }
    if (this.point.land_dismantling_estimate == '済' || this.point.land_dismantling_estimate == '不要') {
      this.point.land_points++;
    }
    if (this.point.land_preparation == '有' || this.point.land_preparation == '無') {
      this.point.land_points++;
    }
    if (this.point.land_preparation_estimate == '済' || this.point.land_preparation_estimate == '不要') {
      this.point.land_points++;
    }
    if (this.point.land_sewage == '有' || this.point.land_sewage == '無') {
      this.point.land_points++;
    }
    if (this.point.land_sewage_estimate == '済' || this.point.land_sewage_estimate == '不要') {
      this.point.land_points++;
    }

    if (this.point.land_bound == '済' || this.point.land_bound == '不要') {
      this.point.land_points++;
    }

    if (this.point.capital_finance_type == '自己資金' || this.point.capital_finance_type == '借入') {
      this.point.capital_points++;
    }
    if (this.point.capital_identification == '済' || this.point.capital_identification == '不要') {
      this.point.capital_points++;
    }
    if (this.point.capital_rough_finance_plan == '済') {
      this.point.capital_points++;
    }
    if (this.point.capital_finance_plan == '済') {
      this.point.capital_points++;
    }

    if (this.point.plan_hearing == 'ニコニコ住宅' || this.point.plan_hearing == '平屋本舗' || this.point.plan_hearing == 'フリープラン' || this.point.plan_hearing == '注文住宅' || this.point.plan_hearing == 'リフォーム' || this.point.plan_hearing == '中古') {
      this.point.plan_points++;
    }
    if (this.point.plan_confirm == 'ニコニコ住宅' || this.point.plan_confirm == '平屋本舗' || this.point.plan_confirm == 'フリープラン' || this.point.plan_confirm == '注文住宅' || this.point.plan_confirm == 'リフォーム' || this.point.plan_confirm == '中古') {
      this.point.plan_points++;
    }
    if (this.point.plan_approval == 'ニコニコ住宅' || this.point.plan_approval == '平屋本舗' || this.point.plan_approval == 'フリープラン' || this.point.plan_approval == '注文住宅' || this.point.plan_approval == 'リフォーム' || this.point.plan_approval == '中古') {
      this.point.plan_points++;
    }

    if (this.point.conflict == '済') {
      this.point.conflict_points++;
    }

    if (this.point.affected == '賛成' || this.point.affected == '不要') {
      this.point.affected_points++;
    }

    if (this.point.time_timing == '済') {
      this.point.time_points++;
    }

    if (this.point.visit_model == '済' || this.point.visit_model == '不要') {
      this.point.visit_points++;
    }

    if (this.input.division_code != 3) {
      if (this.point.capital_comp == '成立') {
        this.point.capital_points++;
      }
      if (this.point.capital_health_insurance == '済' || this.point.capital_health_insurance == '不要') {
        this.point.capital_points++;
      }
      if (this.point.capital_temporary_subsecription == '済' || this.point.capital_temporary_subsecription == '不要') {
        this.point.capital_points++;
      }
      if (this.point.capital_temporary_approval == '済' || this.point.capital_temporary_approval == '不要') {
        this.point.capital_points = this.point.capital_points + 2;
      } else if (this.point.capital_temporary_approval == '留保') {
        this.point.capital_points++;
      }

      if (this.point.visit_construct == '済' || this.point.visit_construct == '不要') {
        this.point.visit_points++;
      }
      if (this.point.visit_ob == '済' || this.point.visit_ob == '不要') {
        this.point.visit_points++;
      }

      if (this.point.app_pay == '済') {
        this.point.app_poins++;
      }
    } else if (this.input.division_code == 3) {
      if (this.point.land_value == '済' || this.point.land_value == '不要') {
        this.point.land_points++;
      }
      if (this.point.land_lord_entering == '済' || this.point.land_lord_entering == '不要') {
        this.point.land_points++;
      }
      if (this.point.land_lease == '済' || this.point.land_lease == '不要') {
        this.point.land_points++;
      }

      if (this.point.capital_balance_plan == '済' || this.point.capital_balance_plan == '不要') {
        this.point.capital_points++;
      }
      if (this.point.capital_privacy == '済' || this.point.capital_privacy == '不要') {
        this.point.capital_points++;
      }
      if (this.point.capital_loan_consultant == '済' || this.point.capital_loan_consultant == '不要') {
        this.point.capital_points++;
      }

      if (this.point.plan_suggestion == '実施済') {
        this.point.plan_points++;
      }
      if (this.point.plan_law == '不要' || this.point.plan_law == '実施済') {
        this.point.plan_points++;
      }

      if (this.point.opertor_open_confirm == '済' || this.point.opertor_open_confirm == '不要') {
        this.point.opertor_points++;
      }
      if (this.point.opertor_sublease == '済' || this.point.opertor_sublease == '不要') {
        this.point.opertor_points++;
      }
    }

    this.point.total_points = this.point.land_points + this.point.capital_points + this.point.plan_points + this.point.conflict_points + this.point.affected_points + this.point.time_points + this.point.visit_points + this.point.opertor_points + this.point.app_poins;


    //ランク計算用
    //申込済
    if (this.point.status >= 7 && this.point.total_points >= 25) {
      //プラン＆承認図書
      if ((this.point.plan_confirm == '未決定' || this.point.plan_confirm == '') && (this.point.plan_approval == '未受領' || this.point.plan_approval == '')) {
        //見積依頼(解体工事/造成工事/上下水道)＆境界確定案内＆資金計画書
        if ((this.point.land_dismantling_estimate == '未' || this.point.land_dismantling_estimate == '') || (this.point.land_preparation_estimate == '未' || this.point.land_preparation_estimate == '') || (this.point.land_sewage_estimate == '未' || this.point.land_sewage_estimate == '') || (this.point.land_bound == '未' || this.point.land_bound == '') || (this.point.capital_finance_plan == '未' || this.point.capital_finance_plan == '')) {
          this.point.rank = 3;//B
        } else {
          this.point.rank = 2;//A
        }
      } else {
        //事前承認
        if (this.point.capital_temporary_approval == '未' || this.point.capital_temporary_approval == '否決' || this.point.capital_temporary_approval == '') {
          this.point.rank = 1;//S
        } else {
          this.point.rank = 1;//SS?
        }
      }
      //追客アポあり
    } else if (this.point.status >= 5 && this.point.total_points >= 8) {
      //公図＆謄本(土地/建物)＆測量図(土地/建物)＆買付申込書＆本人確認書類＆健康保険証＆仮申込書記入＆ヒアリング
      if (this.point.total_points >= 20 && (this.point.land_public_figure == '済' || this.point.land_public_figure == '不要') && (this.point.land_transcript_land == '無' || this.point.land_transcript_land == '済') && (this.point.land_transcript_build == '無' || this.point.land_transcript_build == '済') && (this.point.land_survey_land == '無' || this.point.land_survey_land == '済') && (this.point.land_survey_build == '無' || this.point.land_survey_build == '済') && (this.point.land_buying == '済' || this.point.land_buying == '不要') && (this.point.capital_identification == '済' || this.point.capital_identification == '不要') && (this.point.capital_health_insurance == '済' || this.point.capital_health_insurance == '不要' || this.input.division_code == 3) && (this.point.capital_temporary_subsecription == '済' || this.point.capital_temporary_subsecription == '不要' || this.input.division_code == 3) && (this.point.plan_hearing != '' && this.point.plan_hearing != '未決定' && this.point.plan_hearing != '未実施')) {
        this.point.rank = 4;//C
      } else {
        //影響者
        if (this.point.affected == '賛成' || this.point.affected == '不要') {
          this.point.rank = 5;//D
        } else {
          //競合
          if (this.point.conflict == '済') {
            this.point.rank = 6;//E
          } else {
            //時期
            if (this.point.time_timing == '済') {
              this.point.rank = 7;//F
            } else {
              this.point.rank = 8;//G
            }
          }
        }
      }
    } else {
      this.point.rank = 8;//G
    }

    //引き渡し済
    if ((this.point.status >= 13 && this.input.division_code != 3) || (this.point.status >= 11 && this.input.division_code == 3)) {
      if (!this.point.rank_ob) {
        this.point.rank_ob = "3";
        this.point.introduction = "3";
      }
    }
  }

  //obランキング変動用
  obRank1() {
    if (this.point.introduction == "1") {
      this.point.rank_ob = "1";//プラチナ
    } else if (this.point.introduction == "2") {
      this.point.rank_ob = "2";//ゴールド
    } else if (this.point.introduction == "3") {
      this.point.rank_ob = "3";//シルバー
    }
  }
  obRank2() {
    if (this.point.warning) {
      this.point.rank_ob = "4";//ブロンズ
    } else {
      if (this.point.introduction == "1") {
        this.point.rank_ob = "1";//プラチナ
      } else if (this.point.introduction == "2") {
        this.point.rank_ob = "2";//ゴールド
      } else if (this.point.introduction == "3") {
        this.point.rank_ob = "3";//シルバー
      }
    }
  }


  //土地
  land_owner_1 = { flg: true, title: '有' }
  land_owner_2 = { flg: true, title: '無' }
  //買付申込書
  land_buying_1 = { flg: false, title: '未' }
  land_buying_2 = { flg: false, title: '済' }
  land_buying_3 = { flg: false, title: '不要' }
  //地主の承諾書
  land_lord_consent_1 = { flg: false, title: '未' }
  land_lord_consent_2 = { flg: false, title: '済' }
  land_lord_consent_3 = { flg: false, title: '不要' }

  //解体工事
  land_dismantling_1 = { flg: true, title: '未' }
  land_dismantling_2 = { flg: true, title: '有' }
  land_dismantling_3 = { flg: true, title: '無' }
  //解体工事見積依頼
  land_dismantling_estimate_1 = { flg: false, title: '未' }
  land_dismantling_estimate_2 = { flg: false, title: '済' }
  land_dismantling_estimate_3 = { flg: false, title: '不要' }

  //造成工事
  land_preparation_1 = { flg: true, title: '未' }
  land_preparation_2 = { flg: true, title: '有' }
  land_preparation_3 = { flg: true, title: '無' }
  //造成工事見積依頼
  land_preparation_estimate_1 = { flg: false, title: '未' }
  land_preparation_estimate_2 = { flg: false, title: '済' }
  land_preparation_estimate_3 = { flg: false, title: '不要' }

  //上下水道取出
  land_sewage_1 = { flg: true, title: '未' }
  land_sewage_2 = { flg: true, title: '有' }
  land_sewage_3 = { flg: true, title: '無' }
  //上下水道取出見積依頼
  land_sewage_estimate_1 = { flg: false, title: '未' }
  land_sewage_estimate_2 = { flg: false, title: '済' }
  land_sewage_estimate_3 = { flg: false, title: '不要' }

  check1() {
    const target1 = this._el.nativeElement.querySelector('#land_buying_1');
    const target2 = this._el.nativeElement.querySelector('#land_buying_2');
    const target3 = this._el.nativeElement.querySelector('#land_buying_3');
    const target4 = this._el.nativeElement.querySelector('#land_lord_consent_1');
    const target5 = this._el.nativeElement.querySelector('#land_lord_consent_2');
    const target6 = this._el.nativeElement.querySelector('#land_lord_consent_3');
    if (!this.land_buying_1.flg) {
      this.renderer.setProperty(target1, 'checked', false)
    }
    if (!this.land_buying_2.flg) {
      this.renderer.setProperty(target2, 'checked', false)
    }
    if (!this.land_buying_3.flg) {
      this.renderer.setProperty(target3, 'checked', false)
    }
    if (!this.land_lord_consent_1.flg) {
      this.renderer.setProperty(target4, 'checked', false)
    }
    if (!this.land_lord_consent_2.flg) {
      this.renderer.setProperty(target5, 'checked', false)
    }
    if (!this.land_lord_consent_3.flg) {
      this.renderer.setProperty(target6, 'checked', false)
    }
  }
  check7() {
    const target1 = this._el.nativeElement.querySelector('#land_dismantling_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_dismantling_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_dismantling_estimate_3');
    if (!this.land_dismantling_estimate_1.flg) {
      this.renderer.setProperty(target1, 'checked', false)
    }
    if (!this.land_dismantling_estimate_1.flg) {
      this.renderer.setProperty(target2, 'checked', false)
    }
    if (!this.land_dismantling_estimate_1.flg) {
      this.renderer.setProperty(target3, 'checked', false)
    }
  }
  check8() {
    const target1 = this._el.nativeElement.querySelector('#land_preparation_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_preparation_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_preparation_estimate_3');
    if (!this.land_preparation_estimate_1.flg) {
      this.renderer.setProperty(target1, 'checked', false)
    }
    if (!this.land_preparation_estimate_1.flg) {
      this.renderer.setProperty(target2, 'checked', false)
    }
    if (!this.land_preparation_estimate_1.flg) {
      this.renderer.setProperty(target3, 'checked', false)
    }
  }
  check9() {
    const target1 = this._el.nativeElement.querySelector('#land_sewage_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_sewage_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_sewage_estimate_3');
    if (!this.land_sewage_estimate_1.flg) {
      this.renderer.setProperty(target1, 'checked', false)
    }
    if (!this.land_sewage_estimate_1.flg) {
      this.renderer.setProperty(target2, 'checked', false)
    }
    if (!this.land_sewage_estimate_1.flg) {
      this.renderer.setProperty(target3, 'checked', false)
    }
  }

  canCheck1_1() {
    const target1 = this._el.nativeElement.querySelector('#land_buying_1');
    const target2 = this._el.nativeElement.querySelector('#land_buying_2');
    const target3 = this._el.nativeElement.querySelector('#land_buying_3');
    const target4 = this._el.nativeElement.querySelector('#land_lord_consent_1');
    const target5 = this._el.nativeElement.querySelector('#land_lord_consent_2');
    const target6 = this._el.nativeElement.querySelector('#land_lord_consent_3');

    this.renderer.setProperty(target4, 'disabled', '');
    this.renderer.setProperty(target5, 'disabled', '');
    this.ds_flg = false;
    if (target6.disabled) {
      this.point.land_lord_consent = '';
      this.renderer.setProperty(target6, 'checked', false);
      this.ds_flg = true;
    }
    this.renderer.setProperty(target6, 'disabled', '');

    this.land_buying_1.flg = false;
    this.land_buying_2.flg = false;
    this.land_buying_3.flg = true;
    this.land_lord_consent_1.flg = true;
    this.land_lord_consent_2.flg = true;
    this.land_lord_consent_3.flg = true;

    if (!this.point.land_owner || (this.point.land_owner == this.land_owner_2.title && this.ds_flg)) {
      this.renderer.setProperty(target1, 'disabled', 'disabled');
      this.renderer.setProperty(target2, 'disabled', 'disabled');
      this.renderer.setProperty(target3, 'checked', true);
      this.point.land_buying = '不要';
      this.renderer.setProperty(target3, 'disabled', 'disabled');
      // this.groundSurveyNotInput(true);
    } else {
      this.renderer.setProperty(target1, 'disabled', '');
      this.renderer.setProperty(target2, 'disabled', '');
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_buying = '';
      this.renderer.setProperty(target3, 'disabled', '');
      // this.groundSurveyNotInput(false);
    }
  }
  groundSurveyNotInput(flg) {
    if (flg) {
      // this.schedule.ground_survey_request_date = null;
      // this.schedule.ground_survey_implement_date = null;
      // this.schedule.ground_survey_request_date_target = null;
      //  this.schedule.ground_survey_implement_date_target = null;
      this.schedule.land_contract_target_date = null;
      this.schedule.land_contract_result_date = null;
      this.schedule.land_settlement_target_date = null;
      this.schedule.land_settlement_result_date = null;
    }
    this.gsrd_flg = flg;
    this.gsid_flg = flg;
  }

  canCheck1_2() {
    const target1 = this._el.nativeElement.querySelector('#land_buying_1');
    const target2 = this._el.nativeElement.querySelector('#land_buying_2');
    const target3 = this._el.nativeElement.querySelector('#land_buying_3');
    const target4 = this._el.nativeElement.querySelector('#land_lord_consent_1');
    const target5 = this._el.nativeElement.querySelector('#land_lord_consent_2');
    const target6 = this._el.nativeElement.querySelector('#land_lord_consent_3');
    this.renderer.setProperty(target1, 'disabled', '');
    this.renderer.setProperty(target2, 'disabled', '');
    this.ds_flg = false;
    if (target3.disabled) {
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_buying = '';
      this.ds_flg = true;
    }
    this.renderer.setProperty(target3, 'disabled', '');

    this.land_buying_1.flg = true;
    this.land_buying_2.flg = true;
    this.land_buying_3.flg = true;
    this.land_lord_consent_1.flg = false;
    this.land_lord_consent_2.flg = false;
    this.land_lord_consent_3.flg = true;

    if (!this.point.land_owner || (this.point.land_owner == this.land_owner_1.title && this.ds_flg)) {
      this.renderer.setProperty(target4, 'disabled', 'disabled');
      this.renderer.setProperty(target5, 'disabled', 'disabled');
      this.renderer.setProperty(target6, 'checked', true);
      this.point.land_lord_consent = '不要';
      this.renderer.setProperty(target6, 'disabled', 'disabled');
      this.groundSurveyNotInput(false);
    } else {
      this.renderer.setProperty(target4, 'disabled', '');
      this.renderer.setProperty(target5, 'disabled', '');
      this.renderer.setProperty(target6, 'checked', false);
      this.point.land_lord_consent = '';
      this.renderer.setProperty(target6, 'disabled', '');
      this.groundSurveyNotInput(false);
    }
  }
  radioChecked_lo(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && ((this.land_owner_1.title == this.point.land_owner && id == "#land_owner_1") || (this.land_owner_2.title == this.point.land_owner && id == "#land_owner_2"))) {
      if (this.land_owner_1.title == this.point.land_owner) {
        this.canCheck1_1();
      } else if (this.land_owner_2.title == this.point.land_owner) {
        this.canCheck1_2();
      }
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_owner = '';
    }
    this.pointCount();
  }

  canCheck7_1() {
    const target1 = this._el.nativeElement.querySelector('#land_dismantling_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_dismantling_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_dismantling_estimate_3');

    this.land_dismantling_estimate_1.flg = true;
    this.land_dismantling_estimate_2.flg = true;
    this.land_dismantling_estimate_3.flg = true;

    this.renderer.setProperty(target1, 'disabled', '');
    this.renderer.setProperty(target2, 'disabled', '');
    if (target3.disabled) {
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_dismantling_estimate = '';
    }
    this.renderer.setProperty(target3, 'disabled', '');
    this.dismantlingNotInput(false);
  }
  canCheck7_2() {
    const target1 = this._el.nativeElement.querySelector('#land_dismantling_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_dismantling_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_dismantling_estimate_3');

    this.land_dismantling_estimate_1.flg = false;
    this.land_dismantling_estimate_2.flg = false;
    this.land_dismantling_estimate_3.flg = true;

    if (!this.point.land_dismantling || this.point.land_dismantling !== this.land_dismantling_3.title) {
      this.renderer.setProperty(target1, 'disabled', 'disabled');
      this.renderer.setProperty(target2, 'disabled', 'disabled');
      this.renderer.setProperty(target3, 'checked', true);
      this.point.land_dismantling_estimate = '不要';
      this.renderer.setProperty(target3, 'disabled', 'disabled');
      this.dismantlingNotInput(true);
    } else {
      this.renderer.setProperty(target1, 'disabled', '');
      this.renderer.setProperty(target2, 'disabled', '');
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_dismantling_estimate = '';
      this.renderer.setProperty(target3, 'disabled', '');
      this.dismantlingNotInput(false);
    }
  }
  dismantlingNotInput(flg) {
    if (flg) {
      this.schedule.dismantling_start_date = null;
      this.schedule.dismantling_end_date = null;
      this.schedule.dismantling_start_date_target = null;
      this.schedule.dismantling_end_date_target = null;
    }
    this.dsd_flg = flg;
    this.ded_flg = flg;
  }

  radioChecked_ldm(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_dismantling_1.title == this.point.land_dismantling && id == "#land_dismantling_1") || (this.land_dismantling_2.title == this.point.land_dismantling && id == "#land_dismantling_2") || (this.land_dismantling_3.title == this.point.land_dismantling && id == "#land_dismantling_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_dismantling = '';
    }
    this.pointCount();
  }

  canCheck8_1() {
    const target1 = this._el.nativeElement.querySelector('#land_preparation_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_preparation_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_preparation_estimate_3');

    this.land_preparation_estimate_1.flg = true;
    this.land_preparation_estimate_2.flg = true;
    this.land_preparation_estimate_3.flg = true;

    this.renderer.setProperty(target1, 'disabled', '');
    this.renderer.setProperty(target2, 'disabled', '');
    if (target3.disabled) {
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_preparation_estimate = '';
    }
    this.renderer.setProperty(target3, 'disabled', '');
    this.gardenNotInput(false);
  }
  canCheck8_2() {
    const target1 = this._el.nativeElement.querySelector('#land_preparation_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_preparation_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_preparation_estimate_3');

    this.land_preparation_estimate_1.flg = false;
    this.land_preparation_estimate_2.flg = false;
    this.land_preparation_estimate_3.flg = true;

    if (!this.point.land_preparation || this.point.land_preparation !== this.land_preparation_3.title) {
      this.renderer.setProperty(target1, 'disabled', 'disabled');
      this.renderer.setProperty(target2, 'disabled', 'disabled');
      this.renderer.setProperty(target3, 'checked', true);
      this.point.land_preparation_estimate = '不要';
      this.renderer.setProperty(target3, 'disabled', 'disabled');
      this.gardenNotInput(true);
    } else {
      this.renderer.setProperty(target1, 'disabled', '');
      this.renderer.setProperty(target2, 'disabled', '');
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_preparation_estimate = '';
      this.renderer.setProperty(target3, 'disabled', '');
      this.gardenNotInput(false);
    }
  }
  gardenNotInput(flg) {
    if (flg) {
      this.schedule.garden_start_date = null;
      this.schedule.garden_end_date = null;
      this.schedule.garden_start_date_target = null;
      this.schedule.garden_end_date_target = null;
    }
    this.gsd_flg = flg;
    this.ged_flg = flg;
  }
  radioChecked_lpp(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_preparation_1.title == this.point.land_preparation && id == "#land_preparation_1") || (this.land_preparation_2.title == this.point.land_preparation && id == "#land_preparation_2") || (this.land_preparation_3.title == this.point.land_preparation && id == "#land_preparation_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_preparation = '';
    }
    this.pointCount();
  }

  canCheck9_1() {
    const target1 = this._el.nativeElement.querySelector('#land_sewage_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_sewage_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_sewage_estimate_3');

    this.land_sewage_estimate_1.flg = true;
    this.land_sewage_estimate_2.flg = true;
    this.land_sewage_estimate_3.flg = true;

    this.renderer.setProperty(target1, 'disabled', '');
    this.renderer.setProperty(target2, 'disabled', '');
    if (target3.disabled) {
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_sewage_estimate = '';
    }
    this.renderer.setProperty(target3, 'disabled', '');
  }
  canCheck9_2() {
    const target1 = this._el.nativeElement.querySelector('#land_sewage_estimate_1');
    const target2 = this._el.nativeElement.querySelector('#land_sewage_estimate_2');
    const target3 = this._el.nativeElement.querySelector('#land_sewage_estimate_3');

    this.land_sewage_estimate_1.flg = false;
    this.land_sewage_estimate_2.flg = false;
    this.land_sewage_estimate_3.flg = true;

    if (!this.point.land_sewage || this.point.land_sewage !== this.land_sewage_3.title) {
      this.renderer.setProperty(target1, 'disabled', 'disabled');
      this.renderer.setProperty(target2, 'disabled', 'disabled');
      this.renderer.setProperty(target3, 'checked', true);
      this.point.land_sewage_estimate = '不要';
      this.renderer.setProperty(target3, 'disabled', 'disabled');
    } else {
      this.renderer.setProperty(target1, 'disabled', '');
      this.renderer.setProperty(target2, 'disabled', '');
      this.renderer.setProperty(target3, 'checked', false);
      this.point.land_sewage_estimate = '';
      this.renderer.setProperty(target3, 'disabled', '');
    }
  }
  radioChecked_lsw(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_sewage_1.title == this.point.land_sewage && id == "#land_sewage_1") || (this.land_sewage_2.title == this.point.land_sewage && id == "#land_sewage_2") || (this.land_sewage_3.title == this.point.land_sewage && id == "#land_sewage_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_sewage = '';
    }
    this.pointCount();
  }

  radioChecked_gender(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.input.gender) {
      this.renderer.setProperty(target, 'checked', false);
      this.input.gender = '';
    }
    this.pointCount();
  }
  radioChecked_cm(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.input.contact_method) {
      this.renderer.setProperty(target, 'checked', false);
      this.input.contact_method = '';
    }
    this.pointCount();
  }
  radioChecked_fs(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.family_structure) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.family_structure = '';
    }
    this.pointCount();
  }
  radioChecked_children(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.children) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.children = '';
    }
    this.pointCount();
  }
  radioChecked_income(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.income) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.income = '';
    }
    this.pointCount();
  }
  radioChecked_car(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.car) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.car = '';
    }
    this.pointCount();
  }
  radioChecked_q_land(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.q_land) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.q_land = '';
    }
    this.pointCount();
  }
  radioChecked_a4(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a4) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a4 = '';
    }
    if (this.question.a4 != '時期未定') {
      this.question.a4_memo = '';
    }
    this.pointCount();
  }
  radioChecked_a4_memo(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a4_memo) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a4_memo = '';
    }
    // this.pointCount();
  }
  radioChecked_a5(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a5) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a5 = '';
    }
    this.pointCount();
  }
  radioChecked_a6(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a6) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a6 = '';
    }
    this.pointCount();
  }
  radioChecked_a7_1(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a7_1) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a7_1 = '';
    }
    this.pointCount();
  }
  radioChecked_a7_2(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a7_2) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a7_2 = '';
    }
    this.pointCount();
  }
  radioChecked_a7_3(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a7_3) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a7_3 = '';
    }
    this.pointCount();
  }
  radioChecked_a7_4(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a7_4) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a7_4 = '';
    }
    this.pointCount();
  }
  radioChecked_a7_5(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.question.a7_5) {
      this.renderer.setProperty(target, 'checked', false);
      this.question.a7_5 = '';
    }
    this.pointCount();
  }
  radioChecked_ob(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.introduction) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.introduction = '';
    }
    this.pointCount();
  }
  radioChecked_vc(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.visit_construct) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.visit_construct = '';
    }
    this.pointCount();
  }
  radioChecked_vm(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.visit_model) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.visit_model = '';
    }
    this.pointCount();
  }
  radioChecked_vo(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.visit_ob) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.visit_ob = '';
    }
    this.pointCount();
  }
  radioChecked_app(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.app_pay) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.app_pay = '';
    }
    this.pointCount();
  }
  radioChecked_lb(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_buying_1.title == this.point.land_buying && id == "#land_buying_1") || (this.land_buying_2.title == this.point.land_buying && id == "#land_buying_2") || (this.land_buying_3.title == this.point.land_buying && id == "#land_buying_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_buying = '';
    }
    this.pointCount();
  }
  radioChecked_llc(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_lord_consent_1.title == this.point.land_lord_consent && id == "#land_lord_consent_1") || (this.land_lord_consent_2.title == this.point.land_lord_consent && id == "#land_lord_consent_2") || (this.land_lord_consent_3.title == this.point.land_lord_consent && id == "#land_lord_consent_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_lord_consent = '';
    }
    this.pointCount();
  }
  radioChecked_lpf(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_public_figure) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_public_figure = '';
    }
    this.pointCount();
  }
  radioChecked_ltl(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_transcript_land) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_transcript_land = '';
    }
    this.pointCount();
  }
  radioChecked_ltb(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_transcript_build) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_transcript_build = '';
    }
    this.pointCount();
  }
  radioChecked_lsl(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_survey_land) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_survey_land = '';
    }
    this.pointCount();
  }
  radioChecked_lsb(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_survey_build) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_survey_build = '';
    }
    this.pointCount();
  }
  radioChecked_lv(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_value) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_value = '';
    }
    this.pointCount();
  }
  radioChecked_lle(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_lord_entering) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_lord_entering = '';
    }
    this.pointCount();
  }
  radioChecked_lsv(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_survey) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_survey = '';
    }
    this.pointCount();
  }
  radioChecked_lde(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_dismantling_estimate_1.title == this.point.land_dismantling_estimate && id == "#land_dismantling_estimate_1") || (this.land_dismantling_estimate_2.title == this.point.land_dismantling_estimate && id == "#land_dismantling_estimate_2") || (this.land_dismantling_estimate_3.title == this.point.land_dismantling_estimate && id == "#land_dismantling_estimate_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_dismantling_estimate = '';
    }
    this.pointCount();
  }
  radioChecked_lpe(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_preparation_estimate_1.title == this.point.land_preparation_estimate && id == "#land_preparation_estimate_1") || (this.land_preparation_estimate_2.title == this.point.land_preparation_estimate && id == "#land_preparation_estimate_2") || (this.land_preparation_estimate_3.title == this.point.land_preparation_estimate && id == "#land_preparation_estimate_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_preparation_estimate = '';
    }
    this.pointCount();
  }
  radioChecked_lse(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && (this.land_sewage_estimate_1.title == this.point.land_sewage_estimate && id == "#land_sewage_estimate_1") || (this.land_sewage_estimate_2.title == this.point.land_sewage_estimate && id == "#land_sewage_estimate_2") || (this.land_sewage_estimate_3.title == this.point.land_sewage_estimate && id == "#land_sewage_estimate_3")) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_sewage_estimate = '';
    }
    this.pointCount();
  }
  radioChecked_ll(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_lease) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_lease = '';
    }
    this.pointCount();
  }
  radioChecked_lbnd(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.land_bound) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.land_bound = '';
    }
    this.pointCount();
  }
  radioChecked_cft(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_finance_type) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_finance_type = '';
    }
    this.pointCount();
  }
  radioChecked_cmp(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_comp) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_comp = '';
    }
    this.pointCount();
  }
  radioChecked_cbp(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_balance_plan) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_balance_plan = '';
    }
    this.pointCount();
  }
  radioChecked_cidt(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_identification) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_identification = '';
    }
    this.pointCount();
  }
  radioChecked_cpry(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_privacy) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_privacy = '';
    }
    this.pointCount();
  }
  radioChecked_chi(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_health_insurance) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_health_insurance = '';
    }
    this.pointCount();
  }
  radioChecked_cts(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_temporary_subsecription) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_temporary_subsecription = '';
    }
    this.pointCount();
  }
  radioChecked_cta(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_temporary_approval) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_temporary_approval = '';
    }
    this.pointCount();
  }
  radioChecked_clc(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_loan_consultant) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_loan_consultant = '';
    }
    this.pointCount();
  }
  radioChecked_crfp(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_rough_finance_plan) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_rough_finance_plan = '';
    }
    this.pointCount();
  }
  radioChecked_cfp(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.capital_finance_plan) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.capital_finance_plan = '';
    }
    this.pointCount();
  }
  radioChecked_ph(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_hearing) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_hearing = '';
    }
    this.pointCount();
  }
  radioChecked_ps(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_suggestion) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_suggestion = '';
    }
    this.pointCount();
  }
  radioChecked_pcnf(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_confirm) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_confirm = '';
    }
    this.pointCount();
  }
  radioChecked_plaw(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_law) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_law = '';
    }
    this.pointCount();
  }
  radioChecked_appr(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_approval) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_approval = '';
    }
    this.pointCount();
  }
  radioChecked_slr(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.plan_solar) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.plan_solar = '';
    }
    this.pointCount();
  }
  radioChecked_cnfl(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.conflict) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.conflict = '';
    }
    this.pointCount();
  }
  radioChecked_aff(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.affected) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.affected = '';
    }
    this.pointCount();
  }
  radioChecked_tt(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.time_timing) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.time_timing = '';
    }
    this.pointCount();
  }
  radioChecked_oop(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.opertor_open_confirm) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.opertor_open_confirm = '';
    }
    this.pointCount();
  }
  radioChecked_osb(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.point.opertor_sublease) {
      this.renderer.setProperty(target, 'checked', false);
      this.point.opertor_sublease = '';
    }
    this.pointCount();
  }
  radioChecked_flat(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.schedule.flat) {
      this.renderer.setProperty(target, 'checked', false);
      this.schedule.flat = '';
      if ((id == "#flat1" || id == "#flat2") && this.schedule.midway_check_flg !== "なし") {
        this.schedule.midway_check_flg = null;
        this.mcd_flg = false;
      }
    } else {
      if (id == "#flat1" || id == "#flat2") {
        this.schedule.midway_check_flg = "なし";
        this.schedule.midway_check_date = null;
        this.schedule.midway_check_date_target = null;
        this.mcd_flg = true;
      } else {
        if (this.schedule.midway_check_flg !== "なし") {
          this.schedule.midway_check_flg = null;
          this.mcd_flg = false;
        }
      }
    }

    this.pointCount();
  }
  radioChecked_solar(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.schedule.solar) {
      this.renderer.setProperty(target, 'checked', false);
      this.schedule.solar = '';
    }
    this.pointCount();
  }
  radioChecked_improvement(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked && target.value == this.schedule.improvement_flg) {
      this.renderer.setProperty(target, 'checked', false);
      this.schedule.improvement_flg = '';
      this.groundImprovementNotInput(false);
    } else {
      if (id == "#improvement_flg2") {
        this.groundImprovementNotInput(true);
      } else {
        this.groundImprovementNotInput(false);
      }
    }
    this.pointCount();
  }
  groundImprovementNotInput(flg) {
    if (flg) {
      this.schedule.ground_improvement_date_target = null;
      this.schedule.ground_improvement_date = null;
    }
    this.gid_flg = flg;
  }

  otherResuestNotInput(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked) {
      this.schedule.other_resuest_date1 = null;
      this.schedule.other_resuest_approval_date1 = null;
      this.schedule.other_resuest_date2 = null;
      this.schedule.other_resuest_approval_date2 = null;
      this.schedule.other_resuest_date3 = null;
      this.schedule.other_resuest_approval_date3 = null;
      this.schedule.other_resuest_date4 = null;
      this.schedule.other_resuest_approval_date4 = null;
      this.schedule.other_resuest_date1_target = null;
      this.schedule.other_resuest_approval_date1_target = null;
      this.schedule.other_resuest_date2_target = null;
      this.schedule.other_resuest_approval_date2_target = null;
      this.schedule.other_resuest_date3_target = null;
      this.schedule.other_resuest_approval_date3_target = null;
      this.schedule.other_resuest_date4_target = null;
      this.schedule.other_resuest_approval_date4_target = null;
      this.ord_flg = true;
    } else {
      this.ord_flg = false;
    }
  }
  midwayCheckInput(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked) {
      this.schedule.midway_check_date_target = null;
      this.schedule.midway_check_date = null;
      this.mcd_flg = true;
    } else {
      this.mcd_flg = false;
    }
  }
  groundPrayerCheckInput(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked) {
      this.schedule.ground_prayer_target = null;
      this.schedule.ground_prayer = null;
      this.gpn_flg = true;
    } else {
      this.gpn_flg = false;
    }
  }
  furnitureCarryoutInput(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked) {
      this.schedule.furniture_carryout_start_date_target = null;
      this.schedule.furniture_carryout_end_date_target = null;
      this.schedule.furniture_carryout_start_date = null;
      this.schedule.furniture_carryout_end_date = null;
      this.fcd_flg = true;
    } else {
      this.fcd_flg = false;
    }
  }
  completeVisitInput(id: string) {
    const target = this._el.nativeElement.querySelector(id);
    if (target.checked) {
      this.schedule.complete_visit_start_date_target = null;
      this.schedule.complete_visit_end_date_target = null;
      this.schedule.complete_visit_start_date = null;
      this.schedule.complete_visit_end_date = null;
      this.cvd_flg = true;
    } else {
      this.cvd_flg = false;
    }
  }

  defaultInputNot() {
    if (this.schedule.improvement_flg == "なし") {
      this.groundImprovementNotInput(true);
    }
    if (this.point.land_owner == "有") {
      this.gsrd_flg = true;
      this.gsid_flg = true;
    }
    if (this.point.land_dismantling == "無") {
      this.dsd_flg = true;
      this.ded_flg = true;
    }
    if (this.point.land_preparation == "無") {
      this.gsd_flg = true;
      this.ged_flg = true;
    }
    if (this.schedule.other_resuest_flg) {
      this.ord_flg = true;
    }
    if (this.schedule.ground_prayer_none) {
      this.gpn_flg = true;
    }
    if (this.schedule.midway_check_flg) {
      this.mcd_flg = true;
    }
    if (this.schedule.furniture_carryout_flg) {
      this.fcd_flg = true;
    }
    if (this.schedule.complete_visit_flg) {
      this.cvd_flg = true;
    }
  }

  //日
  setDay(year: string, month: string) {
    this.days = this.formService.formSetDay(year, month)
  }
  setDay1(year: string, month: string) {
    this.days1 = this.formService.formSetDay(year, month)
  }
  setDay2(year: string, month: string) {
    this.days2 = this.formService.formSetDay(year, month)
  }
  setDay3(year: string, month: string) {
    this.days3 = this.formService.formSetDay(year, month)
  }
  setDay4(year: string, month: string) {
    this.days4 = this.formService.formSetDay(year, month)
  }
  setDay5(year: string, month: string) {
    this.days5 = this.formService.formSetDay(year, month)
  }
  //年齢計算
  birthDay(year: string, month: string, date: string) {
    if (year == null || month == null || date == null) {
      this.input.age = "";
    } else {
      const BirthDay = {
        year: parseInt(year, 10),
        month: parseInt(month, 10),
        date: parseInt(date, 10)
      };
      const birthDate = new Date(BirthDay.year, BirthDay.month - 1, BirthDay.date);

      const y2 = birthDate.getFullYear().toString().padStart(4, '0');
      const m2 = (birthDate.getMonth() + 1).toString().padStart(2, '0');
      const d2 = birthDate.getDate().toString().padStart(2, '0');

      const today = new Date();
      const y1 = today.getFullYear().toString().padStart(4, '0');
      const m1 = (today.getMonth() + 1).toString().padStart(2, '0');
      const d1 = today.getDate().toString().padStart(2, '0');

      const age_res = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);

      this.input.birthday = y2 + '-' + m2 + '-' + d2;
      this.input.age = age_res;
    }
  }

  formatDate1(date, format) {
    format = format.replace(/yyyy/g, date.getFullYear());
    format = format.replace(/M/g, (date.getMonth() + 1));
    format = format.replace(/d/g, (date.getDate()));
    format = format.replace(/H/g, (date.getHours()));
    format = format.replace(/m/g, (date.getMinutes()));
    format = format.replace(/s/g, (date.getSeconds()));
    format = format.replace(/S/g, (date.getMilliseconds()));
    return format;
  };

  formatDate2(date, format) {
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, (date.getMonth() + 1));
    format = format.replace(/DD/g, (date.getDate()));
    format = format.replace(/hh/g, (date.getHours()));
    format = format.replace(/mm/g, (date.getMinutes()));
    format = format.replace(/s/g, (date.getSeconds()));
    format = format.replace(/S/g, (date.getMilliseconds()));
    return format;
  };

  dateArr(datetime) {
    var date = {
      year: parseInt(this.formatDate2(new Date(datetime), 'YYYY'), 10),
      month: parseInt(this.formatDate2(new Date(datetime), 'MM'), 10),
      day: parseInt(this.formatDate2(new Date(datetime), 'DD'), 10),
    }
    return date;
  }

  //住所検索
  searchZip(zip: string) {
    if (zip.length == 7) {
      const zip1 = zip.substr(0, 3);
      const zip2 = zip.substr(3, 7);

      var httpGetObservable = this.http.get("https://yubinbango.github.io/yubinbango-data/data/" + zip1 + ".js");
      var zipAddr = {};

      httpGetObservable.subscribe(
        res => {
          var resString = res.text();
          zipAddr = resString.replace(/yubin/g, '').replace("$", '').replace("(", '').replace(")", '');
          zipAddr = (new Function("return " + zipAddr))();

          var addr = zipAddr[zip];
          if (addr !== undefined) {
            this.input.pref = addr['0'];
            this.input.city = addr['1'];
            this.input.address = addr['2'];
          }
        },
        error => {
          //console.error(error.status + ":" + error.statusText);
        }
      );
    }
  }
  dp_flg;
  openDp(datePicker) {
    if (this.dp_flg) {
      if (this.dp_flg.isOpen()) {
        if (datePicker == this.dp_flg) {
          this.dp_flg = datePicker;
        } else {
          this.dp_flg.close();
          this.dp_flg = datePicker;
        }
      } else if (datePicker == this.dp_flg) {
        this.dp_flg.close();
        this.dp_flg = "";
      }
    } else {
      this.dp_flg = datePicker;
    }
  }
  closeDp(event) {
    if (this.tab === "panel3" || this.tab === "panel4" || this.tab === "panel5") {
      if (this.dp_flg && (event.target.offsetParent == null || event.target.offsetParent.nodeName != "NGB-DATEPICKER")) {
        this.dp_flg.close();
        this.dp_flg = "";
      }
    }
  }

  getEventList(date: Date) {
    this.eventAllList = [];
    this.eventList = [];
    this.calendar.getEeventCal(0,
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      this.logininfo.user_code,
      '1'
    ).subscribe((data: any[]) => {
      data.forEach(event => {
        this.eventAllList.push(event);
      });
    });
  }
  filterEventList(view) {
    if (!view.date) return;
    let selectDate = StringUtil.Object2Str(view.date);
    this.eventList = this.eventAllList.filter((event) => {
      let startDate = this.getDate(event.start);
      let endDate = this.getDate(event.end);
      return !!(selectDate >= startDate && selectDate <= endDate);
    });
  }
  getDate(datetime) {
    // datetimeの文字列から から dateのみの文字列にする
    let dt = new Date(datetime);
    return StringUtil.date2Str(new Date(datetime));
  }
  getPlaceholder(item) {
    if (this.question[item] == 'インターネット検索') {
      return '検索ワード';
    }
    if (this.question[item] == '新聞の折込チラシ') {
      return '購読している新聞';
    }
    if (this.question[item] == 'その他の雑誌') {
      return '雑誌名';
    }
    if (this.question[item] == 'その他') {
      return '具体的に';
    }
    return '';
  }
}
